import { useContext, useEffect, useState } from "react";
import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import Checks from "../../bootstrap/forms/Checks";
import FormGroup from "../../bootstrap/forms/FormGroup";
import Input from "../../bootstrap/forms/Input";
import Select from "../../bootstrap/forms/Select";
import { toasts } from "../../../services/toast.service";
import { useFormik } from "formik";
import AlertService from "../../../services/AlertService";
import { useNavigate, useParams } from "react-router-dom";
import SubHeader, { SubHeaderLeft, SubheaderSeparator } from "../../../layout/SubHeader/SubHeader";
import Button from "../../bootstrap/Button";
import { getProfileForStudent, getStudentDetailsByStudentDetailsId, updateStudentDetails } from "../../../services/student.service";
import { getBlood, getCategory, getCity, getConcession, getGenderDetails, getGraduationType, getMotherTongue, getReligion, getSectionDetails, getStates, onlyAllowNumber, pictNotLoading, profilePic, profilePicUpload } from "../../../services/common.service";
import { getLicenseKey } from "../../../services/application.settings";
import AuthContext from "../../../contexts/authContext";
import { getBatchByCourseId, getCasteDetails, getCourse, getDepartmentList, getReferralType, getSemester, getUserListByUserTypeId } from "../../../services/master.service";
import { getStudentSchoolName, getStudentSchoolSubject } from "../../../services/administration.service";
import { getTransportAreaMaster } from "../../../services/transport.service";
import Card, { CardBody,CardHeader, CardLabel, CardTitle } from "../../bootstrap/Card";
import Popovers from "../../bootstrap/Popovers";
import classNames from "classnames";
import useDarkMode from "../../../hooks/useDarkMode";
import { showLoader } from "../../../services/loader.services";
import SearchableSelect from "../../../common/components/SearchableSelect";

const UpdateStudent = () => {

    const navigate = useNavigate();
    const { studentDetailsId } = useParams();
    const [step, setStep] = useState<number>(0);
    const totalSteps: number = 5;

    const handleNext = () => {
        if (step < totalSteps) {
            setStep(step + 1);
        }
    };

    const handlePrevious = () => {
        setStep(step - 1);
    };

    const handleStepClick = (newStep: any) => {
        setStep(newStep);
    };

    useEffect(() => {
        getGraduationList();
        getGender();
        getBloodList();
        getMotherTongueList();
        getCategoryDetails();
        getReligionDetails();
        getCaste();
        getStatesList();
        getPermAddr_State();
        getDepartment();
        getSectionList();
        getStudentSchoolNameList();
        getStudentSchoolSubjectList();

        getReferral();
        getConcessionList();
        getTransportAreaMasterDetails();
        getStudentDetailsByStudentDetails(studentDetailsId);
        getStudentProfile(studentDetailsId);
    }, [])

    const { userAccountId, userTypeId } = useContext(AuthContext);
    const { themeStatus, darkModeStatus } = useDarkMode();

    const [graduationTypeId, setGraduationTypeId] = useState('')
    const [commAddr_StateId, setCommAddr_StateId] = useState<any>('')
    const [commAddr_CityId, setCommAddr_CityId] = useState<any>('')

    const [permAddr_StateId, setPermAddr_StateId] = useState<any>('')
    const [permAddr_CityId, setPermAddr_CityId] = useState<any>('')


    const [graduationTypeData, setGraduationTypeData] = useState<any>([])
    const [genderData, setGenderData] = useState<any>([])
    const [bloodData, setBloodData] = useState<any>([])
    const [motherTongueData, setMotherTongueData] = useState<any>([])
    const [categoryData, setCategoryData] = useState<any>([])
    const [religionData, setReligionData] = useState<any>([])
    const [casteDetailsData, setCasteDetailsData] = useState<any>([])

    const [statesData, setStatesData] = useState<any>([])
    const [cityData, setCityData] = useState<any>([])
    const [permAddr_StateData, setPermAddr_StateData] = useState<any>([])
    const [permAddr_CityData, setPermAddr_CityData] = useState<any>([])

    const [departmentId, setDepartmentId] = useState('')
    const [courseId, setCourseId] = useState('')
    const [batchMasterId, setBatchMasterId] = useState('')
    const [semesterDetailsId, setSemesterDetailsId] = useState('')
    const [sectionDetailsId, setSectionDetailsId] = useState<any>('')

    const [departmentData, setDepartmentData] = useState<any>([])
    const [courseData, setCourseData] = useState<any>([])
    const [batchMasterData, setBatchMasterData] = useState<any>([])
    const [semesterDetailsData, setSemesterDetailsData] = useState<any>([])
    const [sectionDetailsData, setSectionDetailsData] = useState<any>([])
    const [studentSchoolNameData, setStudentSchoolNameData] = useState<any>([])
    //XI subject
    const [studentSchoolSubjectData, setStudentSchoolSubjectData] = useState<any>([])

    const [interestedCourseData, setInterestedCourseData] = useState<any>([])
    const [referralTypeId, setReferralTypeId] = useState<any>('')
    const [referralTypeData, setReferralTypeData] = useState<any>([])
    const [userListByUserTypeData, setUserListByUserTypeData] = useState<any>([])
    const [concessionData, setConcessionData] = useState<any>([])
    const [transportAreaMasterData, setTransportAreaMasterData] = useState<any>([])

    const [studentDetailsData, setStudentDetailsData] = useState([])
    const [permAddr_FlatNo, setPermAddr_FlatNo] = useState<any>('')
    const [permAddr_Street, setPermAddr_Street] = useState<any>('')
    const [permAddr_Area, setPermAddr_Area] = useState<any>('')
    const [permAddr_Pincode, setPermAddr_Pincode] = useState<any>('')

    const [isReferralTypeOthers, setIsReferralTypeOthers] = useState(false)
    const [selectedFile, setSelectedFile] = useState<any>()
    const [isCollegeTransport, setTransportId] = useState('')
    const [isTransportDetails, setIsTransportDetails] = useState('isTransportDetails')
    const [nationality, setIsNationality] = useState('')
    const [isOtherNation, setIsOtherNation] = useState('isOthers')
    const [physicallyChallenged, setPhysicallyChallenged] = useState('')
    const [isPhysicallyChallengedDetails, setIsPhysicallyChallengedDetails] = useState('isPhysicallyChallengedDetails')
    const [interimCollegeTransfer, setIsInterimCollegeTransfer] = useState('')
    const [totalPercentageForXI, setTotalPercentageForXI] = useState('')
    const [totalPercentageForXII, setTotalPercentageForXII] = useState('')

    // For Alert
    const [alertStatus, setAlertStatus] = useState<any>({ message: "", type: "" });
    const [isOpen, setIsOpen] = useState(false);
    const [isNavigate, setIsNavigate] = useState<any>(null);


    const [studentProfileData, setStudentProfileData] = useState<any>([])
    const [profilePath, setProfilePath] = useState(null);

    const [genderId, setGenderId] = useState<any>('')
    const [bloodGroupId, setBloodGroupId] = useState<any>('')
    const [motherTongue, setMotherTongue] = useState<any>('')
    const [religionId, setReligionId] = useState<any>('')
    const [category, setCategory] = useState<any>('')
    const [casteDetailsId, setCasteDetailsId] = useState<any>('')
    const [transferCourseId, setTransferCourseId] = useState<any>('')
    const [referredId, setReferredId] = useState<any>('')
    const [referredName, setReferredName] = useState('')
    const [concessionTypeId, setConcessionTypeId] = useState<any>('')
    const [concessionRemarks, setConcessionRemarks] = useState<any>('')

    const [XIISchoolNameId, setXIISchoolNameId] = useState<any>('')
    const [XI_S1_studentSchoolSubject, setXI_S1_studentSchoolSubject] = useState<any>('')
    const [XI_S2_studentSchoolSubject, setXI_S2_studentSchoolSubject] = useState<any>('')
    const [XI_S3_studentSchoolSubject, setXI_S3_studentSchoolSubject] = useState<any>('')
    const [XI_S4_studentSchoolSubject, setXI_S4_studentSchoolSubject] = useState<any>('')
    const [XI_S5_studentSchoolSubject, setXI_S5_studentSchoolSubject] = useState<any>('')
    const [XI_S6_studentSchoolSubject, setXI_S6_studentSchoolSubject] = useState<any>('')
    const [XII_S1_studentSchoolSubject, setXII_S1_studentSchoolSubject] = useState<any>('')
    const [XII_S2_studentSchoolSubject, setXII_S2_studentSchoolSubject] = useState<any>('')
    const [XII_S3_studentSchoolSubject, setXII_S3_studentSchoolSubject] = useState<any>('')
    const [XII_S4_studentSchoolSubject, setXII_S4_studentSchoolSubject] = useState<any>('')
    const [XII_S5_studentSchoolSubject, setXII_S5_studentSchoolSubject] = useState<any>('')
    const [XII_S6_studentSchoolSubject, setXII_S6_studentSchoolSubject] = useState<any>('')

    const [ugDegree, setUgDegree] = useState(false)
    const [pgDegree, setPgDegree] = useState(false)

    const [transportAreaValue, setTransportAreaValue] = useState('')
    const [modeValue, setModeValue] = useState('')

    const [otherNationValue, setOtherNationValue] = useState('')
    const [physicallyChallengedTypeValue, setPhysicallyChallengedTypeValue] = useState('')
    const [physicallyChallengedPercentageValue, setPhysicallyChallengedPercentageValue] = useState('')
    const [collegeNameValue, setCollegeNameValue] = useState('')
    const [isGuardian, setIsGuardian] = useState<any>(0);
    const [isChecked, setIsChecked] = useState(false)

    const updateStudentForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            ///----General Info----////
            studentDetailsId: '',
            profilePath: '',
            graduationTypeId: '',
            admissionNo: '',
            tempNo: '',
            firstName: '',
            lastName: '',
            surName: '',
            studentNameTamil: '',
            surNameTamil: '',
            dateOfBirth: '',
            genderId: '',
            bloodGroupId: '',
            motherTongue: '',
            nationality: '',
            otherNation: '',
            religionId: '',
            casteUniqueId: '',
            casteDetailsId: '',
            subcaste: '',
            category: '',
            aadharCard: '',
            physicallyChallenged: '',
            physicallyChallengedType: '',
            physicallyChallengedPercentage: '',
            martialStatus: '',
            email: '',
            uniRegNo: '',
            emisNo: '',
            smsToBeSentNumber: '',
        },
        validate: (values: any) => {
            const errors: {
                graduationTypeId?: string;
                batchMasterId?: string;
                semesterDetailsId?: string;
                admissionNo?: string;
                firstName?: string;
                aadharCard?: string;
                email?: string;
                smsToBeSentNumber?: string;

            } = {};
            if (!graduationTypeId) {
                errors.graduationTypeId = 'Required';
            }
            if (!values.admissionNo) {
                errors.admissionNo = 'Required';
            }
            if (!batchMasterId) {
                errors.batchMasterId = 'Required';
            }
            if (!semesterDetailsId) {
                errors.semesterDetailsId = 'Required';
            }
            if (!values.firstName) {
                errors.firstName = 'Required'
            }
            else if (values.firstName.length < 3) {
                errors.firstName = 'Must be 3 characters or more';
            } else if (values.firstName.length > 20) {
                errors.firstName = 'Must be 20 characters or less';
            }
            if (values.aadharCard && !/^\d{12}$/.test(values.aadharCard)) {
                errors.aadharCard = 'Must be 12 Numbers';
            }
            // if (values.email) {
            //     errors.email = 'Required'
            // }
            // else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            //     errors.email = 'Invalid email address';
            // }
            if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
                errors.email = 'Invalid email address';
            }
            if (!values.smsToBeSentNumber) {
                errors.smsToBeSentNumber = 'Required'
            }
            else if (!/^\d{10}$/.test(values.smsToBeSentNumber)) {
                errors.smsToBeSentNumber = 'Must be 10 Numbers';
            }

            return errors;
        },
        //validateOnChange: false,
        onSubmit: (values) => { handleNext() },
    })

    const addressForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            commAddr_FlatNo: '',
            commAddr_Street: '',
            commAddr_Area: '',
            commAddr_StateId: '',
            commAddr_CityId: '',
            commAddr_Pincode: '',
            permAddr_FlatNo: '',
            permAddr_Street: '',
            permAddr_Area: '',
            permAddr_StateId: '',
            permAddr_CityId: '',
            permAddr_Pincode: '',

            bankName: '',
            bankAccountNo: '',
            branch: '',
            ifscCode: '',
            micrCode: '',
        },
        validate: (values) => {
            const errors: {
                commAddr_Pincode?: string;
                permAddr_Pincode?: string;
            } = {};
            if (values.commAddr_Pincode && !/^\d{6}$/.test(values.commAddr_Pincode)) {
                errors.commAddr_Pincode = 'Must be 6 Numbers';
            }
            if (values.permAddr_Pincode && !/^\d{6}$/.test(values.permAddr_Pincode)) {
                errors.permAddr_Pincode = 'Must be 6 Numbers';
            }
            return errors;
        },
        //validateOnChange: false,
        onSubmit: () => { handleNext() },
    });

    const classForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            // ///----Class INFO----////

            departmentId: '',
            courseId: '',
            batchMasterId: '',
            semesterDetailsId: '',
            sectionDetailsId: '',
            studentRollNo: '',
            admissionDateStamp: '',
            sourceName: '',
            transferCourseId: '',
            referralTypeId: '',
            referredId: '',
            referredName: '',
            interimCollegeTransfer: '',
            collegeName: '',
            concessionTypeId: '',
            concessionRemarks: '',
            transportAreaMasterId: '',
            modeOfWays: '',
            isCollegeTransport: '',
        },
        validate: (values) => { },
        //validateOnChange: false,
        onSubmit: () => { handleNext() },
    });

    const familyForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            ///----Family INFO----////
            fatherName: '',
            father_AdharNumber: '',
            fatherOccupation: '',
            natureofJoborBusiness: '',
            fatherContactNumber: '',
            fatherEmailId: '',
            motherName: '',
            mother_AdharNumber: '',
            yearlyIncome: '',
            positionHeld: '',
            motherContactNumber: '',
            guardian_Name: '',
            guardian_email: '',
            guardian_phone: '',
            guardian_AdharNumber: '',
            isGuardian: '',
        },
        validate: (values) => {
            const errors: {
                motherContactNumber?: string;
                father_AdharNumber?: string;
                fatherContactNumber?: string;
                fatherEmailId?: string;
                mother_AdharNumber?: string;
                guardian_email?: string;
                guardian_phone?: string;
                guardian_AdharNumber?: string;
            } = {};
            if (values.father_AdharNumber && !/^\d{12}$/.test(values.father_AdharNumber)) {
                errors.father_AdharNumber = 'Must be 12 Numbers';
            }
            if (values.fatherContactNumber && !/^\d{10}$/.test(values.fatherContactNumber)) {
                errors.fatherContactNumber = 'Must be 10 Numbers';
            }
            if (values.fatherEmailId && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.fatherEmailId)) {
                errors.fatherEmailId = 'Invalid email address';
            }
            if (values.mother_AdharNumber && !/^\d{12}$/.test(values.mother_AdharNumber)) {
                errors.mother_AdharNumber = 'Must be 12 Numbers';
            }
            if (values.motherContactNumber && !/^\d{10}$/.test(values.motherContactNumber)) {
                errors.motherContactNumber = 'Must be 10 Numbers';
            }
            if (values.guardian_AdharNumber && !/^\d{12}$/.test(values.guardian_AdharNumber)) {
                errors.guardian_AdharNumber = 'Must be 12 Numbers';
            }
            if (values.guardian_phone && !/^\d{10}$/.test(values.guardian_phone)) {
                errors.guardian_phone = 'Must be 10 Numbers';
            }
            if (values.guardian_email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.guardian_email)) {
                errors.guardian_email = 'Invalid email address';
            }
            return errors;
        },
        //validateOnChange: false,
        onSubmit: () => { handleNext() },
    });

    const markForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            // // ///----MARK INFO----////
            registerNo_X: '',
            institutionNameAndAddress_X: '',
            boardName_X: '',
            mediumOfInstitution_X: '',
            monthAndYearOfPassing_X: '',

            registerNo_XI: '',
            institutionNameAndAddress_XI: '',
            boardName_XI: '',
            mediumOfInstitution_XI: '',
            monthAndYearOfPassing_XI: '',

            registerNo_XII: '',
            XIISchoolNameId: '',
            boardName_XII: '',
            mediumOfInstitution_XII: '',
            monthAndYearOfPassing_XII: '',

            XI_S1_studentSchoolSubject: '',
            XI_S1_markSecured: '',
            XI_S1_maximumMarks: '',
            XI_S1_monthAndYearOfPassing: '',
            XI_S1_registerNo: '',
            XI_S1_noOfAttempts: '',
            XI_S2_studentSchoolSubject: '',
            XI_S2_markSecured: '',
            XI_S2_maximumMarks: '',
            XI_S2_monthAndYearOfPassing: '',
            XI_S2_registerNo: '',
            XI_S2_noOfAttempts: '',
            XI_S3_studentSchoolSubject: '',
            XI_S3_markSecured: '',
            XI_S3_maximumMarks: '',
            XI_S3_monthAndYearOfPassing: '',
            XI_S3_registerNo: '',
            XI_S3_noOfAttempts: '',
            XI_S4_studentSchoolSubject: '',
            XI_S4_markSecured: '',
            XI_S4_maximumMarks: '',
            XI_S4_monthAndYearOfPassing: '',
            XI_S4_registerNo: '',
            XI_S4_noOfAttempts: '',
            XI_S5_studentSchoolSubject: '',
            XI_S5_markSecured: '',
            XI_S5_maximumMarks: '',
            XI_S5_monthAndYearOfPassing: '',
            XI_S5_registerNo: '',
            XI_S5_noOfAttempts: '',
            XI_S6_studentSchoolSubject: '',
            XI_S6_markSecured: '',
            XI_S6_maximumMarks: '',
            XI_S6_monthAndYearOfPassing: '',
            XI_S6_registerNo: '',
            XI_S6_noOfAttempts: '',

            XII_S1_studentSchoolSubject: '',
            XII_S1_markSecured: '',
            XII_S1_maximumMarks: '',
            XII_S1_monthAndYearOfPassing: '',
            XII_S1_registerNo: '',
            XII_S1_noOfAttempts: '',
            XII_S2_studentSchoolSubject: '',
            XII_S2_markSecured: '',
            XII_S2_maximumMarks: '',
            XII_S2_monthAndYearOfPassing: '',
            XII_S2_registerNo: '',
            XII_S2_noOfAttempts: '',
            XII_S3_studentSchoolSubject: '',
            XII_S3_markSecured: '',
            XII_S3_maximumMarks: '',
            XII_S3_monthAndYearOfPassing: '',
            XII_S3_registerNo: '',
            XII_S3_noOfAttempts: '',
            XII_S4_studentSchoolSubject: '',
            XII_S4_markSecured: '',
            XII_S4_maximumMarks: '',
            XII_S4_monthAndYearOfPassing: '',
            XII_S4_registerNo: '',
            XII_S4_noOfAttempts: '',
            XII_S5_studentSchoolSubject: '',
            XII_S5_markSecured: '',
            XII_S5_maximumMarks: '',
            XII_S5_monthAndYearOfPassing: '',
            XII_S5_registerNo: '',
            XII_S5_noOfAttempts: '',
            XII_S6_studentSchoolSubject: '',
            XII_S6_markSecured: '',
            XII_S6_maximumMarks: '',
            XII_S6_monthAndYearOfPassing: '',
            XII_S6_registerNo: '',
            XII_S6_noOfAttempts: '',

            XI_OverAll_markSecured: '',
            XI_OverAll_maximumMarks: '',
            XII_OverAll_markSecured: '',
            XII_OverAll_maximumMarks: '',

            registerNo_UG: '',
            institutionNameAndAddress_UG: '',
            universityName_UG: '',
            mediumOfInstitution_UG: '',
            monthAndYearOfPassing_UG: '',

            registerNo_PG: '',
            institutionNameAndAddress_PG: '',
            universityName_PG: '',
            mediumOfInstitution_PG: '',
            monthAndYearOfPassing_PG: '',

            registerNo_MPhil: '',
            institutionNameAndAddress_MPhil: '',
            universityName_MPhil: '',
            mediumOfInstitution_MPhil: '',
            monthAndYearOfPassing_MPhil: '',

            UG_courseName: '',
            UG_Part1_SubjectName: '',
            UG_Part1_MarksObtained: '',
            UG_Part1_MaximumMarks: '',
            UG_Part1_Percentage: '',
            UG_Part1_ClassObtained: '',
            UG_Part1_NoOfAttempts: '',
            UG_Part1_RegisterNo: '',
            UG_Part1_Passing: '',
            UG_Part2_SubjectName: '',
            UG_Part2_MarksObtained: '',
            UG_Part2_MaximumMarks: '',
            UG_Part2_Percentage: '',
            UG_Part2_ClassObtained: '',
            UG_Part2_NoOfAttempts: '',
            UG_Part2_RegisterNo: '',
            UG_Part2_Passing: '',
            UG_Part3_SubjectName: '',
            UG_Part3_MarksObtained: '',
            UG_Part3_MaximumMarks: '',
            UG_Part3_Percentage: '',
            UG_Part3_ClassObtained: '',
            UG_Part3_NoOfAttempts: '',
            UG_Part3_RegisterNo: '',
            UG_Part3_Passing: '',
            UG_Allied1_SubjectName: '',
            UG_Allied1_MarksObtained: '',
            UG_Allied1_MaximumMarks: '',
            UG_Allied1_Percentage: '',
            UG_Allied1_ClassObtained: '',
            UG_Allied1_NoOfAttempts: '',
            UG_Allied1_RegisterNo: '',
            UG_Allied1_Passing: '',
            UG_Allied2_SubjectName: '',
            UG_Allied2_MarksObtained: '',
            UG_Allied2_MaximumMarks: '',
            UG_Allied2_Percentage: '',
            UG_Allied2_ClassObtained: '',
            UG_Allied2_NoOfAttempts: '',
            UG_Allied2_RegisterNo: '',
            UG_Allied2_Passing: '',
            UG_Overall_Main_Core: '',
            UG_Overall_Ancy_Allied: '',
            UG_Overall_Part3: '',

            PG_courseName: '',
            PG_Part1_SubjectName: '',
            PG_Part1_MarksObtained: '',
            PG_Part1_MaximumMarks: '',
            PG_Part1_Percentage: '',
            PG_Part1_ClassObtained: '',
            PG_Part1_NoOfAttempts: '',
            PG_Part1_RegisterNo: '',
            PG_Part1_Passing: '',
            PG_Part2_SubjectName: '',
            PG_Part2_MarksObtained: '',
            PG_Part2_MaximumMarks: '',
            PG_Part2_Percentage: '',
            PG_Part2_ClassObtained: '',
            PG_Part2_NoOfAttempts: '',
            PG_Part2_RegisterNo: '',
            PG_Part2_Passing: '',
            PG_Part3_SubjectName: '',
            PG_Part3_MarksObtained: '',
            PG_Part3_MaximumMarks: '',
            PG_Part3_Percentage: '',
            PG_Part3_ClassObtained: '',
            PG_Part3_NoOfAttempts: '',
            PG_Part3_RegisterNo: '',
            PG_Part3_Passing: '',
            PG_Allied1_SubjectName: '',
            PG_Allied1_MarksObtained: '',
            PG_Allied1_MaximumMarks: '',
            PG_Allied1_Percentage: '',
            PG_Allied1_ClassObtained: '',
            PG_Allied1_NoOfAttempts: '',
            PG_Allied1_RegisterNo: '',
            PG_Allied1_Passing: '',
            PG_Allied2_SubjectName: '',
            PG_Allied2_MarksObtained: '',
            PG_Allied2_MaximumMarks: '',
            PG_Allied2_Percentage: '',
            PG_Allied2_ClassObtained: '',
            PG_Allied2_NoOfAttempts: '',
            PG_Allied2_RegisterNo: '',
            PG_Allied2_Passing: '',
            PG_Overall_Main_Core: '',
            PG_Overall_Ancy_Allied: '',
            PG_Overall_Part3: '',

            MPhil_courseName: '',
            MPhil_Part1_SubjectName: '',
            MPhil_Part1_MarksObtained: '',
            MPhil_Part1_MaximumMarks: '',
            MPhil_Part1_Percentage: '',
            MPhil_Part1_ClassObtained: '',
            MPhil_Part1_NoOfAttempts: '',
            MPhil_Part1_RegisterNo: '',
            MPhil_Part1_Passing: '',
            MPhil_Part2_SubjectName: '',
            MPhil_Part2_MarksObtained: '',
            MPhil_Part2_MaximumMarks: '',
            MPhil_Part2_Percentage: '',
            MPhil_Part2_ClassObtained: '',
            MPhil_Part2_NoOfAttempts: '',
            MPhil_Part2_RegisterNo: '',
            MPhil_Part2_Passing: '',
            MPhil_Part3_SubjectName: '',
            MPhil_Part3_MarksObtained: '',
            MPhil_Part3_MaximumMarks: '',
            MPhil_Part3_Percentage: '',
            MPhil_Part3_ClassObtained: '',
            MPhil_Part3_NoOfAttempts: '',
            MPhil_Part3_RegisterNo: '',
            MPhil_Part3_Passing: '',
            MPhil_Allied1_SubjectName: '',
            MPhil_Allied1_MarksObtained: '',
            MPhil_Allied1_MaximumMarks: '',
            MPhil_Allied1_Percentage: '',
            MPhil_Allied1_ClassObtained: '',
            MPhil_Allied1_NoOfAttempts: '',
            MPhil_Allied1_RegisterNo: '',
            MPhil_Allied1_Passing: '',
            MPhil_Allied2_SubjectName: '',
            MPhil_Allied2_MarksObtained: '',
            MPhil_Allied2_MaximumMarks: '',
            MPhil_Allied2_Percentage: '',
            MPhil_Allied2_ClassObtained: '',
            MPhil_Allied2_NoOfAttempts: '',
            MPhil_Allied2_RegisterNo: '',
            MPhil_Allied2_Passing: '',
            MPhil_Overall_Main_Core: '',
            MPhil_Overall_Ancy_Allied: '',
            MPhil_Overall_Part3: '',
        },
        validate: (values) => { },
        //validateOnChange: false,
        onSubmit: () => { updateStudentDetailsSubmit() },
    });

    const selectGraduationType = (e: any) => {
        let graduationTypeId = e.target.value
        setGraduationTypeId(graduationTypeId);
        getInterestedCourse(0, graduationTypeId)
        if (graduationTypeId == '2') {
            setUgDegree(true)
        }
        else if (graduationTypeId == '3') {
            setUgDegree(true)
            setPgDegree(true)
        }
        else {
            setUgDegree(false)
            setPgDegree(false)
        }
    }

    const selectReferralType = (e: any) => {
        setReferredId('')
        setReferredName('')
        let referralTypeId = e
        setReferralTypeId(referralTypeId);
        if (referralTypeId?.value != undefined) {
            getUserListByUserType(referralTypeId?.value)
            if (referralTypeId?.value == '11') {
                setIsReferralTypeOthers(false)
            }
            else {
                setIsReferralTypeOthers(true)
            }
        }
    }

    const selectState = (e: any) => {
        setCommAddr_CityId('')
        setCityData([])
        let commAddr_StateId = e
        setCommAddr_StateId(commAddr_StateId)
        if (commAddr_StateId?.value != undefined) {
            getCityList(commAddr_StateId?.value)
        }
    }

    const selectCity = (e: any) => {
        let commAddr_CityId = e
        setCommAddr_CityId(commAddr_CityId)
    }

    const selectPermAddr_State = (e: any) => {
        setPermAddr_CityId('')
        setPermAddr_CityData([])
        let permAddr_StateId = e
        setPermAddr_StateId(permAddr_StateId)
        if (permAddr_StateId?.value != undefined) {
            getPermAddr_StateAndCity(permAddr_StateId?.value)
        }
    }

    const selectPermAddr_City = (e: any) => {
        let permAddr_CityId = e
        setPermAddr_CityId(permAddr_CityId)
    }

    const selectDepartment = (e: any) => {
        let departmentId = e.target.value
        setDepartmentId(departmentId)
        getCourseList(departmentId, graduationTypeId)
    }

    const selectCourse = (e: any) => {
        let courseId = e.target.value
        setCourseId(courseId)
        getBatchList(courseId, graduationTypeId)
    }

    const selectBatch = (e: any) => {
        let batchMasterId = e.target.value
        setBatchMasterId(batchMasterId)
        getSemesterList(batchMasterId)
    }

    const selectSemester = (e: any) => {
        let semesterDetailsId = e.target.value
        setSemesterDetailsId(semesterDetailsId)
    }

    const selectSection = (e: any) => {
        let sectionDetailsId = e
        setSectionDetailsId(sectionDetailsId)
    }
    
    const selectTransport = (e: any) => {
        let isCollegeTransport = e.target.values
        setTransportId(isCollegeTransport)
        getTransportAreaMasterDetails();
        if (isCollegeTransport == 'Yes') {
            setIsTransportDetails('isAreaDetails')
        }
        else {
            setIsTransportDetails('isTransportDetails')
            setTransportAreaValue('')
            setModeValue('')
        }
    }

    const selectConcessionTypeId = (e: any) => {
        setConcessionRemarks('')
        let concessionTypeId = e
        setConcessionTypeId(concessionTypeId)
    }

    function getGraduationList() {
        getGraduationType(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.graduationType;
                    if (data != undefined) {
                        setGraduationTypeData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setGraduationTypeData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getGender() {
        getGenderDetails(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.genderDetails;
                    if (data != undefined) {
                        setGenderData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setGenderData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getBloodList() {
        getBlood(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.blood;
                    if (data != undefined) {
                        setBloodData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setBloodData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getMotherTongueList() {
        getMotherTongue(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.motherTongue;
                    if (data != undefined) {
                        setMotherTongueData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setMotherTongueData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getReligionDetails() {
        getReligion(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.religion;
                    if (data != undefined) {
                        setReligionData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setReligionData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getCategoryDetails() {
        getCategory(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.category;
                    if (data != undefined) {
                        setCategoryData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setCategoryData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getCaste() {
        getCasteDetails(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.casteDetails;
                    if (data != undefined) {
                        setCasteDetailsData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setCasteDetailsData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getStatesList() {
        getStates(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.statesAndCity;
                    if (data != undefined) {
                        setStatesData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setStatesData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getCityList(stateId: any) {
        getCity(stateId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.statesAndCity[0]['city'];
                    if (data != undefined) {
                        setCityData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setCityData([]);
                } else {

                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getPermAddr_State() {
        getStates(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.statesAndCity;
                    if (data != undefined) {
                        setPermAddr_StateData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setPermAddr_StateData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getPermAddr_StateAndCity(stateId: any) {
        getCity(stateId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.statesAndCity[0]['city'];
                    if (data != undefined) {
                        setPermAddr_CityData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setPermAddr_CityData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getDepartment() {
        getDepartmentList(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.department;
                    if (data != undefined) {
                        setDepartmentData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setDepartmentData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getCourseList(departmentId: any, graduationTypeId: any) {
        getCourse(departmentId, graduationTypeId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.course;
                    if (data != undefined) {
                        setCourseData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setCourseData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getBatchList(courseId: any, graduationTypeId: any) {
        getBatchByCourseId(courseId, graduationTypeId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.batchByCourseId;
                    if (data != undefined) {
                        setBatchMasterData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setBatchMasterData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getSemesterList(batchMasterId: number) {
        getSemester(batchMasterId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.semester;
                    if (data != undefined) {
                        setSemesterDetailsData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setSemesterDetailsData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getSectionList() {
        getSectionDetails(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.sectionDetails;
                    if (data != undefined) {
                        setSectionDetailsData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setSectionDetailsData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getStudentSchoolNameList() {
        getStudentSchoolName(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.studentSchoolName;
                    if (data != undefined) {
                        setStudentSchoolNameData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setStudentSchoolNameData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        );
    }

    function getStudentSchoolSubjectList() {
        getStudentSchoolSubject(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.studentSchoolSubject;
                    if (data != undefined) {
                        setStudentSchoolSubjectData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setStudentSchoolSubjectData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getInterestedCourse(departmentId: any, graduationTypeId: any) {
        getCourse(departmentId, graduationTypeId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.course;
                    if (data != undefined) {
                        setInterestedCourseData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setInterestedCourseData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getReferral() {
        getReferralType(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.referralType;
                    if (data != undefined) {
                        setReferralTypeData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    // toasts(response.data.message, "Error")
                    setReferralTypeData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getUserListByUserType(referralTypeId: any) {
        getUserListByUserTypeId(referralTypeId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.userListByUserTypeId;
                    if (data != undefined) {
                        setUserListByUserTypeData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    // toasts(response.data.message, "Error")
                    setUserListByUserTypeData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getConcessionList() {
        getConcession(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.concession;
                    if (data != undefined) {
                        setConcessionData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setConcessionData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getTransportAreaMasterDetails() {
        getTransportAreaMaster(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.transportAreaMaster;
                    if (data != undefined) {
                        setTransportAreaMasterData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setTransportAreaMasterData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getStudentDetailsByStudentDetails(studentDetailsId: any) {
        getStudentDetailsByStudentDetailsId(studentDetailsId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.studentDetailsByStudentDetailsId[0];
                    if (data != undefined) {
                        setStudentDetailsData(data)
                        setProfilePath(data.profilePath);
                        setIsGuardian(data.isGuardian)
                        setGraduationTypeId(data.graduationTypeId)

                        if (data.graduationTypeId == '2') {
                            setUgDegree(true)
                        }
                        else if (data.graduationTypeId == '3') {
                            setUgDegree(true)
                            setPgDegree(true)
                        }
                        else {
                            setUgDegree(false)
                            setPgDegree(false)
                        }

                        setDepartmentId(data.departmentId)
                        setCourseId(data.courseId)
                        setBatchMasterId(data.batchMasterId)
                        setSemesterDetailsId(data.semesterDetailsId)
                        setSectionDetailsId(data.sectionDetailsId != null ? { value: data.sectionDetailsId, label: data.sectionName } : '')
                        setPermAddr_FlatNo(data.permAddr_FlatNo)
                        setPermAddr_Street(data.permAddr_Street)
                        setPermAddr_Area(data.permAddr_Area)
                        setPermAddr_Pincode(data.permAddr_Pincode)

                        if (data.commAddr_StateId != null) {
                            getCityList(data.commAddr_StateId)
                        }
                        if (data.permAddr_StateId != null) {
                            getPermAddr_StateAndCity(data.permAddr_StateId)
                        }

                        setCommAddr_StateId(data.commAddr_StateId != null ? { value: data.commAddr_StateId, label: data.stateName } : '')
                        setCommAddr_CityId(data.commAddr_CityId != null ? { value: data.commAddr_CityId, label: data.cityName } : '')
                        setPermAddr_StateId(data.permAddr_StateId != null ? { value: data.permAddr_StateId, label: data.stateName } : '')
                        setPermAddr_CityId(data.permAddr_CityId != null ? { value: data.permAddr_CityId, label: data.cityName } : '')

                        getInterestedCourse(0, data.graduationTypeId)
                        getCourseList(data.departmentId, data.graduationTypeId)
                        getBatchList(data.courseId, data.graduationTypeId)
                        getSemesterList(data.batchMasterId)


                        setReferralTypeId(data.referralTypeId != null ? { value: data.referralTypeId, label: data.referralType } : '')
                        setReferredId(data.referredId != null ? { value: data.referredId, label: data.registerNoForStudentAndStaff } : '')
                        setReferredName(data.referredName != null ? data.referredName : '')

                        if (data.referralTypeId != null) {
                            getUserListByUserType(data.referralTypeId)
                        }
                        if (data.referralTypeId == 11) {
                            setIsReferralTypeOthers(false)
                        } else {
                            setIsReferralTypeOthers(true)
                        }

                        setModeValue(data.modeOfWays)
                        setTransportAreaValue(data.transportAreaMasterId)
                        setTransportId(data.isCollegeTransport);
                        if (data.isCollegeTransport == 'Yes') {
                            setIsTransportDetails('isAreaDetails')
                        }
                        else {
                            setIsTransportDetails('isTransportDetails')
                            setTransportAreaValue('')
                            setModeValue('')
                        }

                        setOtherNationValue(data.otherNation)
                        setIsNationality(data.nationality)
                        if (data.nationality == 'Others') {
                            setIsOtherNation('Other')
                        }
                        else {
                            setIsOtherNation('isOthers')
                            setOtherNationValue('')
                        }

                        setPhysicallyChallengedTypeValue(data.physicallyChallengedType)
                        setPhysicallyChallengedPercentageValue(data.physicallyChallengedPercentage)
                        setPhysicallyChallenged(data.physicallyChallenged)
                        if (data.physicallyChallenged == 'Yes') {
                            setIsPhysicallyChallengedDetails('YES')
                        }
                        else {
                            setIsPhysicallyChallengedDetails('isPhysicallyChallengedDetails')
                            setPhysicallyChallengedPercentageValue('')
                            setPhysicallyChallengedTypeValue('')
                        }

                        setIsInterimCollegeTransfer(data.interimCollegeTransfer)
                        setCollegeNameValue(data.collegeName != null ? data.collegeName : '')

                        setGenderId(data.genderId != 0 ? { value: data.genderId, label: data.gender } : null)
                        setBloodGroupId(data.bloodGroupId != null ? { value: data.bloodGroupId, label: data.groupName } : '')
                        setMotherTongue(data.bloodGroupId != null ? { value: data.motherTongue, label: data.motherTongue } : '')
                        setReligionId(data.religionId != null ? { value: data.religionId, label: data.religion } : '')
                        setCategory(data.category != null ? { value: data.category, label: data.category } : '')
                        setCasteDetailsId(data.casteDetailsId != null ? { value: data.casteDetailsId, label: data.casteName } : '')
                        setTransferCourseId(data.transferCourseId != null ? { value: data.transferCourseId, label: data.transferCourseName } : '')
                        setConcessionTypeId(data.concessionTypeId != null ? { value: data.concessionTypeId, label: data.concessionType } : '')
                        setConcessionRemarks(data.concessionRemarks)

                        setXIISchoolNameId(data.XIISchoolNameId != null ? { value: data.XIISchoolNameId, label: data.schoolName } : '')
                        setXI_S1_studentSchoolSubject(data.XI_S1_studentSchoolSubject != null ? { value: data.XI_S1_studentSchoolSubject, label: data.XI_S1_studentSchoolSubjectName } : '')
                        setXI_S2_studentSchoolSubject(data.XI_S2_studentSchoolSubject != null ? { value: data.XI_S2_studentSchoolSubject, label: data.XI_S2_studentSchoolSubjectName } : '')
                        setXI_S3_studentSchoolSubject(data.XI_S3_studentSchoolSubject != null ? { value: data.XI_S3_studentSchoolSubject, label: data.XI_S3_studentSchoolSubjectName } : '')
                        setXI_S4_studentSchoolSubject(data.XI_S4_studentSchoolSubject != null ? { value: data.XI_S4_studentSchoolSubject, label: data.XI_S4_studentSchoolSubjectName } : '')
                        setXI_S5_studentSchoolSubject(data.XI_S5_studentSchoolSubject != null ? { value: data.XI_S5_studentSchoolSubject, label: data.XI_S5_studentSchoolSubjectName } : '')
                        setXI_S6_studentSchoolSubject(data.XI_S6_studentSchoolSubject != null ? { value: data.XI_S6_studentSchoolSubject, label: data.XI_S6_studentSchoolSubjectName } : '')
                        setXII_S1_studentSchoolSubject(data.XII_S1_studentSchoolSubject != null ? { value: data.XII_S1_studentSchoolSubject, label: data.XII_S1_studentSchoolSubjectName } : '')
                        setXII_S2_studentSchoolSubject(data.XII_S2_studentSchoolSubject != null ? { value: data.XII_S2_studentSchoolSubject, label: data.XII_S2_studentSchoolSubjectName } : '')
                        setXII_S3_studentSchoolSubject(data.XII_S3_studentSchoolSubject != null ? { value: data.XII_S3_studentSchoolSubject, label: data.XII_S3_studentSchoolSubjectName } : '')
                        setXII_S4_studentSchoolSubject(data.XII_S4_studentSchoolSubject != null ? { value: data.XII_S4_studentSchoolSubject, label: data.XII_S4_studentSchoolSubjectName } : '')
                        setXII_S5_studentSchoolSubject(data.XII_S5_studentSchoolSubject != null ? { value: data.XII_S5_studentSchoolSubject, label: data.XII_S5_studentSchoolSubjectName } : '')
                        setXII_S6_studentSchoolSubject(data.XII_S6_studentSchoolSubject != null ? { value: data.XII_S6_studentSchoolSubject, label: data.XII_S6_studentSchoolSubjectName } : '')

                        updateStudentForm.setValues({
                            studentDetailsId: data['studentDetailsId'],
                            profilePath: data['profilePath'] ? data['profilePath'] : '',
                            graduationTypeId: data['graduationTypeId'] ? data['graduationTypeId'] : '',
                            admissionNo: data['admissionNo'] ? data['admissionNo'] : '',
                            tempNo: data['tempNo'] ? data['tempNo'] : '',
                            firstName: data['firstname'] ? data['firstname'] : '',
                            lastName: data['lastname'] ? data['lastname'] : '',
                            uniRegNo: data['uniRegNo'] ? data['uniRegNo'] : '',
                            surName: data['surName'] ? data['surName'] : '',
                            studentNameTamil: data['studentNameTamil'] ? data['studentNameTamil'] : '',
                            surNameTamil: data['surNameTamil'] ? data['surNameTamil'] : '',
                            dateOfBirth: data['dateOfBirth'] ? data['dateOfBirth'] : '',
                            genderId: data['genderId'] ? data['genderId'] : '',
                            bloodGroupId: data['bloodGroupId'] ? data['bloodGroupId'] : '',
                            motherTongue: data['motherTongue'] ? data['motherTongue'] : '',
                            nationality: data['nationality'] ? data['nationality'] : '',
                            otherNation: data['otherNation'] ? data['otherNation'] : '',
                            religionId: data['religionId'] ? data['religionId'] : '',
                            casteUniqueId: data['casteUniqueId'] ? data['casteUniqueId'] : '',
                            casteDetailsId: data['casteDetailsId'] ? data['casteDetailsId'] : '',
                            subcaste: data['subcaste'] ? data['subcaste'] : '',
                            category: data['category'] ? data['category'] : '',
                            aadharCard: data['aadharCard'] ? data['aadharCard'] : '',
                            physicallyChallenged: data['physicallyChallenged'] ? data['physicallyChallenged'] : '',
                            physicallyChallengedType: data['physicallyChallengedType'] ? data['physicallyChallengedType'] : '',
                            physicallyChallengedPercentage: data['physicallyChallengedPercentage'] ? data['physicallyChallengedPercentage'] : '',
                            martialStatus: data['martialStatus'] ? data['martialStatus'] : '',
                            email: data['email'] ? data['email'] : '',
                            emisNo: data['emisNo'] ? data['emisNo'] : '',
                            smsToBeSentNumber: data['smsToBeSentNumber'] ? data['smsToBeSentNumber'] : '',
                        })
                        addressForm.setValues({
                            commAddr_FlatNo: data['commAddr_FlatNo'] ? data['commAddr_FlatNo'] : '',
                            commAddr_Street: data['commAddr_Street'] ? data['commAddr_Street'] : '',
                            commAddr_Area: data['commAddr_Area'] ? data['commAddr_Area'] : '',
                            commAddr_StateId: data['commAddr_StateId'] ? data['commAddr_StateId'] : '',
                            commAddr_CityId: data['commAddr_CityId'] ? data['commAddr_CityId'] : '',
                            commAddr_Pincode: data['commAddr_Pincode'] ? data['commAddr_Pincode'] : '',
                            permAddr_FlatNo: data['permAddr_FlatNo'] ? data['permAddr_FlatNo'] : '',
                            permAddr_Street: data['permAddr_Street'] ? data['permAddr_Street'] : '',
                            permAddr_Area: data['permAddr_Area'] ? data['permAddr_Area'] : '',
                            permAddr_StateId: data['permAddr_StateId'] ? data['permAddr_StateId'] : '',
                            permAddr_CityId: data['permAddr_CityId'] ? data['permAddr_CityId'] : '',
                            permAddr_Pincode: data['permAddr_Pincode'] ? data['permAddr_Pincode'] : '',
                            bankName: data['bankName'] ? data['bankName'] : '',
                            bankAccountNo: data['bankAccountNo'] ? data['bankAccountNo'] : '',
                            branch: data['branch'] ? data['branch'] : '',
                            ifscCode: data['ifscCode'] ? data['ifscCode'] : '',
                            micrCode: data['micrCode'] ? data['micrCode'] : '',
                        })
                        classForm.setValues({
                            departmentId: data['departmentId'] ? data['departmentId'] : '',
                            courseId: data['courseId'] ? data['courseId'] : '',
                            batchMasterId: data['batchMasterId'] ? data['batchMasterId'] : '',
                            semesterDetailsId: data['semesterDetailsId'] ? data['semesterDetailsId'] : '',
                            sectionDetailsId: data['sectionDetailsId'] ? data['sectionDetailsId'] : '',
                            studentRollNo: data['studentRollNo'] ? data['studentRollNo'] : '',
                            admissionDateStamp: data['admissionDateStamp'] ? data['admissionDateStamp'] : '',
                            sourceName: data['sourceName'] ? data['sourceName'] : '',
                            transferCourseId: data['transferCourseId'] ? data['transferCourseId'] : '',
                            interimCollegeTransfer: data['interimCollegeTransfer'] ? data['interimCollegeTransfer'] : '',
                            collegeName: data['collegeName'] ? data['collegeName'] : '',
                            concessionTypeId: data['concessionTypeId'] ? data['concessionTypeId'] : '',
                            concessionRemarks: data['concessionRemarks'] ? data['concessionRemarks'] : '',
                            transportAreaMasterId: data['transportAreaMasterId'] ? data['transportAreaMasterId'] : '',
                            modeOfWays: data['modeOfWays'] ? data['modeOfWays'] : '',
                            referralTypeId: data['referralTypeId'] != null ? data['referralTypeId'] : 0,
                            referredId: data['referredId'] ? data['referredId'] : '',
                            referredName: data['referredName'] ? data['referredName'] : '',
                            isCollegeTransport: data['isCollegeTransport'] ? data['isCollegeTransport'] : '',
                        })
                        familyForm.setValues({
                            fatherName: data['fatherName'] ? data['fatherName'] : '',
                            father_AdharNumber: data['father_AdharNumber'] ? data['father_AdharNumber'] : '',
                            fatherOccupation: data['fatherOccupation'] ? data['fatherOccupation'] : '',
                            natureofJoborBusiness: data['natureofJoborBusiness'] ? data['natureofJoborBusiness'] : '',
                            fatherContactNumber: data['fatherContactNumber'] ? data['fatherContactNumber'] : '',
                            fatherEmailId: data['fatherEmailId'] ? data['fatherEmailId'] : '',
                            motherName: data['motherName'] ? data['motherName'] : '',
                            mother_AdharNumber: data['mother_AdharNumber'] ? data['mother_AdharNumber'] : '',
                            yearlyIncome: data['yearlyIncome'] ? data['yearlyIncome'] : '',
                            positionHeld: data['positionHeld'] ? data['positionHeld'] : '',
                            motherContactNumber: data['motherContactNumber'] ? data['motherContactNumber'] : '',

                            guardian_Name: data['guardian_Name'] ? data['guardian_Name'] : '',
                            guardian_email: data['guardian_email'] ? data['guardian_email'] : '',
                            guardian_phone: data['guardian_phone'] ? data['guardian_phone'] : '',
                            guardian_AdharNumber: data['guardian_AdharNumber'] ? data['guardian_AdharNumber'] : '',
                            isGuardian: data['isGuardian'] ? data['isGuardian'] : '',
                        })
                        markForm.setValues({
                            registerNo_X: data['registerNo_X'] ? data['registerNo_X'] : '',
                            institutionNameAndAddress_X: data['institutionNameAndAddress_X'] ? data['institutionNameAndAddress_X'] : '',
                            boardName_X: data['boardName_X'] ? data['boardName_X'] : '',
                            mediumOfInstitution_X: data['mediumOfInstitution_X'] ? data['mediumOfInstitution_X'] : '',
                            monthAndYearOfPassing_X: data['monthAndYearOfPassing_X'] ? data['monthAndYearOfPassing_X'] : '',
                            registerNo_XI: data['registerNo_XI'] ? data['registerNo_XI'] : '',
                            institutionNameAndAddress_XI: data['institutionNameAndAddress_XI'] ? data['institutionNameAndAddress_XI'] : '',
                            boardName_XI: data['boardName_XI'] ? data['boardName_XI'] : '',
                            mediumOfInstitution_XI: data['mediumOfInstitution_XI'] ? data['mediumOfInstitution_XI'] : '',
                            monthAndYearOfPassing_XI: data['monthAndYearOfPassing_XI'] ? data['monthAndYearOfPassing_XI'] : '',
                            registerNo_XII: data['registerNo_XII'] ? data['registerNo_XII'] : '',
                            XIISchoolNameId: data['XIISchoolNameId'] ? data['XIISchoolNameId'] : '',
                            boardName_XII: data['boardName_XII'] ? data['boardName_XII'] : '',
                            mediumOfInstitution_XII: data['mediumOfInstitution_XII'] ? data['mediumOfInstitution_XII'] : '',
                            monthAndYearOfPassing_XII: data['monthAndYearOfPassing_XII'] ? data['monthAndYearOfPassing_XII'] : '',

                            XI_S1_studentSchoolSubject: data['XI_S1_studentSchoolSubject'] ? data['XI_S1_studentSchoolSubject'] : '',
                            XI_S1_markSecured: data['XI_S1_markSecured'] ? data['XI_S1_markSecured'] : '',
                            XI_S1_maximumMarks: data['XI_S1_maximumMarks'] ? data['XI_S1_maximumMarks'] : '',
                            XI_S1_monthAndYearOfPassing: data['XI_S1_monthAndYearOfPassing'] ? data['XI_S1_monthAndYearOfPassing'] : '',
                            XI_S1_registerNo: data['XI_S1_registerNo'] ? data['XI_S1_registerNo'] : '',
                            XI_S1_noOfAttempts: data['XI_S1_noOfAttempts'] ? data['XI_S1_noOfAttempts'] : '',

                            XI_S2_studentSchoolSubject: data['XI_S2_studentSchoolSubject'] ? data['XI_S2_studentSchoolSubject'] : '',
                            XI_S2_markSecured: data['XI_S2_markSecured'] ? data['XI_S2_markSecured'] : '',
                            XI_S2_maximumMarks: data['XI_S2_maximumMarks'] ? data['XI_S2_maximumMarks'] : '',
                            XI_S2_monthAndYearOfPassing: data['XI_S2_monthAndYearOfPassing'] ? data['XI_S2_monthAndYearOfPassing'] : '',
                            XI_S2_registerNo: data['XI_S2_registerNo'] ? data['XI_S2_registerNo'] : '',
                            XI_S2_noOfAttempts: data['XI_S2_noOfAttempts'] ? data['XI_S2_noOfAttempts'] : '',

                            XI_S3_studentSchoolSubject: data['XI_S3_studentSchoolSubject'] ? data['XI_S3_studentSchoolSubject'] : '',
                            XI_S3_markSecured: data['XI_S3_markSecured'] ? data['XI_S3_markSecured'] : '',
                            XI_S3_maximumMarks: data['XI_S3_maximumMarks'] ? data['XI_S3_maximumMarks'] : '',
                            XI_S3_monthAndYearOfPassing: data['XI_S3_monthAndYearOfPassing'] ? data['XI_S3_monthAndYearOfPassing'] : '',
                            XI_S3_registerNo: data['XI_S3_registerNo'] ? data['XI_S3_registerNo'] : '',
                            XI_S3_noOfAttempts: data['XI_S3_noOfAttempts'] ? data['XI_S3_noOfAttempts'] : '',

                            XI_S4_studentSchoolSubject: data['XI_S4_studentSchoolSubject'] ? data['XI_S4_studentSchoolSubject'] : '',
                            XI_S4_markSecured: data['XI_S4_markSecured'] ? data['XI_S4_markSecured'] : '',
                            XI_S4_maximumMarks: data['XI_S4_maximumMarks'] ? data['XI_S4_maximumMarks'] : '',
                            XI_S4_monthAndYearOfPassing: data['XI_S4_monthAndYearOfPassing'] ? data['XI_S4_monthAndYearOfPassing'] : '',
                            XI_S4_registerNo: data['XI_S4_registerNo'] ? data['XI_S4_registerNo'] : '',
                            XI_S4_noOfAttempts: data['XI_S4_noOfAttempts'] ? data['XI_S4_noOfAttempts'] : '',

                            XI_S5_studentSchoolSubject: data['XI_S5_studentSchoolSubject'] ? data['XI_S5_studentSchoolSubject'] : '',
                            XI_S5_markSecured: data['XI_S5_markSecured'] ? data['XI_S5_markSecured'] : '',
                            XI_S5_maximumMarks: data['XI_S5_maximumMarks'] ? data['XI_S5_maximumMarks'] : '',
                            XI_S5_monthAndYearOfPassing: data['XI_S5_monthAndYearOfPassing'] ? data['XI_S5_monthAndYearOfPassing'] : '',
                            XI_S5_registerNo: data['XI_S5_registerNo'] ? data['XI_S5_registerNo'] : '',
                            XI_S5_noOfAttempts: data['XI_S5_noOfAttempts'] ? data['XI_S5_noOfAttempts'] : '',

                            XI_S6_studentSchoolSubject: data['XI_S6_studentSchoolSubject'] ? data['XI_S6_studentSchoolSubject'] : '',
                            XI_S6_markSecured: data['XI_S6_markSecured'] ? data['XI_S6_markSecured'] : '',
                            XI_S6_maximumMarks: data['XI_S6_maximumMarks'] ? data['XI_S6_maximumMarks'] : '',
                            XI_S6_monthAndYearOfPassing: data['XI_S6_monthAndYearOfPassing'] ? data['XI_S6_monthAndYearOfPassing'] : '',
                            XI_S6_registerNo: data['XI_S6_registerNo'] ? data['XI_S6_registerNo'] : '',
                            XI_S6_noOfAttempts: data['XI_S6_noOfAttempts'] ? data['XI_S6_noOfAttempts'] : '',

                            XII_S1_studentSchoolSubject: data['XII_S1_studentSchoolSubject'] ? data['XII_S1_studentSchoolSubject'] : '',
                            XII_S1_markSecured: data['XII_S1_markSecured'] ? data['XII_S1_markSecured'] : '',
                            XII_S1_maximumMarks: data['XII_S1_maximumMarks'] ? data['XII_S1_maximumMarks'] : '',
                            XII_S1_monthAndYearOfPassing: data['XII_S1_monthAndYearOfPassing'] ? data['XII_S1_monthAndYearOfPassing'] : '',
                            XII_S1_registerNo: data['XII_S1_registerNo'] ? data['XII_S1_registerNo'] : '',
                            XII_S1_noOfAttempts: data['XII_S1_noOfAttempts'] ? data['XII_S1_noOfAttempts'] : '',

                            XII_S2_studentSchoolSubject: data['XII_S2_studentSchoolSubject'] ? data['XII_S2_studentSchoolSubject'] : '',
                            XII_S2_markSecured: data['XII_S2_markSecured'] ? data['XII_S2_markSecured'] : '',
                            XII_S2_maximumMarks: data['XII_S2_maximumMarks'] ? data['XII_S2_maximumMarks'] : '',
                            XII_S2_monthAndYearOfPassing: data['XII_S2_monthAndYearOfPassing'] ? data['XII_S2_monthAndYearOfPassing'] : '',
                            XII_S2_registerNo: data['XII_S2_registerNo'] ? data['XII_S2_registerNo'] : '',
                            XII_S2_noOfAttempts: data['XII_S2_noOfAttempts'] ? data['XII_S2_noOfAttempts'] : '',

                            XII_S3_studentSchoolSubject: data['XII_S3_studentSchoolSubject'] ? data['XII_S3_studentSchoolSubject'] : '',
                            XII_S3_markSecured: data['XII_S3_markSecured'] ? data['XII_S3_markSecured'] : '',
                            XII_S3_maximumMarks: data['XII_S3_maximumMarks'] ? data['XII_S3_maximumMarks'] : '',
                            XII_S3_monthAndYearOfPassing: data['XII_S3_monthAndYearOfPassing'] ? data['XII_S3_monthAndYearOfPassing'] : '',
                            XII_S3_registerNo: data['XII_S3_registerNo'] ? data['XII_S3_registerNo'] : '',
                            XII_S3_noOfAttempts: data['XII_S3_noOfAttempts'] ? data['XII_S3_noOfAttempts'] : '',

                            XII_S4_studentSchoolSubject: data['XII_S4_studentSchoolSubject'] ? data['XII_S4_studentSchoolSubject'] : '',
                            XII_S4_markSecured: data['XII_S4_markSecured'] ? data['XII_S4_markSecured'] : '',
                            XII_S4_maximumMarks: data['XII_S4_maximumMarks'] ? data['XII_S4_maximumMarks'] : '',
                            XII_S4_monthAndYearOfPassing: data['XII_S4_monthAndYearOfPassing'] ? data['XII_S4_monthAndYearOfPassing'] : '',
                            XII_S4_registerNo: data['XII_S4_registerNo'] ? data['XII_S4_registerNo'] : '',
                            XII_S4_noOfAttempts: data['XII_S4_noOfAttempts'] ? data['XII_S4_noOfAttempts'] : '',

                            XII_S5_studentSchoolSubject: data['XII_S5_studentSchoolSubject'] ? data['XII_S5_studentSchoolSubject'] : '',
                            XII_S5_markSecured: data['XII_S5_markSecured'] ? data['XII_S5_markSecured'] : '',
                            XII_S5_maximumMarks: data['XII_S5_maximumMarks'] ? data['XII_S5_maximumMarks'] : '',
                            XII_S5_monthAndYearOfPassing: data['XII_S5_monthAndYearOfPassing'] ? data['XII_S5_monthAndYearOfPassing'] : '',
                            XII_S5_registerNo: data['XII_S5_registerNo'] ? data['XII_S5_registerNo'] : '',
                            XII_S5_noOfAttempts: data['XII_S5_noOfAttempts'] ? data['XII_S5_noOfAttempts'] : '',

                            XII_S6_studentSchoolSubject: data['XII_S6_studentSchoolSubject'] ? data['XII_S6_studentSchoolSubject'] : '',
                            XII_S6_markSecured: data['XII_S6_markSecured'] ? data['XII_S6_markSecured'] : '',
                            XII_S6_maximumMarks: data['XII_S6_maximumMarks'] ? data['XII_S6_maximumMarks'] : '',
                            XII_S6_monthAndYearOfPassing: data['XII_S6_monthAndYearOfPassing'] ? data['XII_S6_monthAndYearOfPassing'] : '',
                            XII_S6_registerNo: data['XII_S6_registerNo'] ? data['XII_S6_registerNo'] : '',
                            XII_S6_noOfAttempts: data['XII_S6_noOfAttempts'] ? data['XII_S6_noOfAttempts'] : '',

                            XI_OverAll_markSecured: data['XI_OverAll_markSecured'] ? data['XI_OverAll_markSecured'] : '',
                            XI_OverAll_maximumMarks: data['XI_OverAll_maximumMarks'] ? data['XI_OverAll_maximumMarks'] : '',
                            XII_OverAll_markSecured: data['XII_OverAll_markSecured'] ? data['XII_OverAll_markSecured'] : '',
                            XII_OverAll_maximumMarks: data['XII_OverAll_maximumMarks'] ? data['XII_OverAll_maximumMarks'] : '',
                            //
                            registerNo_UG: data['registerNo_UG'],
                            institutionNameAndAddress_UG: data['institutionNameAndAddress_UG'],
                            universityName_UG: data['universityName_UG'],
                            mediumOfInstitution_UG: data['mediumOfInstitution_UG'],
                            monthAndYearOfPassing_UG: data['monthAndYearOfPassing_UG'],

                            registerNo_PG: data['registerNo_PG'],
                            institutionNameAndAddress_PG: data['institutionNameAndAddress_PG'],
                            universityName_PG: data['universityName_PG'],
                            mediumOfInstitution_PG: data['mediumOfInstitution_PG'],
                            monthAndYearOfPassing_PG: data['monthAndYearOfPassing_PG'],

                            registerNo_MPhil: data['registerNo_MPhil'],
                            institutionNameAndAddress_MPhil: data['institutionNameAndAddress_MPhil'],
                            universityName_MPhil: data['universityName_MPhil'],
                            mediumOfInstitution_MPhil: data['mediumOfInstitution_MPhil'],
                            monthAndYearOfPassing_MPhil: data['monthAndYearOfPassing_MPhil'],

                            UG_courseName: data['UG_courseName'],
                            UG_Part1_SubjectName: data['UG_Part1_SubjectName'],
                            UG_Part1_MarksObtained: data['UG_Part1_MarksObtained'],
                            UG_Part1_MaximumMarks: data['UG_Part1_MaximumMarks'],
                            UG_Part1_Percentage: data['UG_Part1_Percentage'],
                            UG_Part1_ClassObtained: data['UG_Part1_ClassObtained'],
                            UG_Part1_NoOfAttempts: data['UG_Part1_NoOfAttempts'],
                            UG_Part1_RegisterNo: data['UG_Part1_RegisterNo'],
                            UG_Part1_Passing: data['UG_Part1_Passing'],

                            UG_Part2_SubjectName: data['UG_Part2_SubjectName'],
                            UG_Part2_MarksObtained: data['UG_Part2_MarksObtained'],
                            UG_Part2_MaximumMarks: data['UG_Part2_MaximumMarks'],
                            UG_Part2_Percentage: data['UG_Part2_Percentage'],
                            UG_Part2_ClassObtained: data['UG_Part2_ClassObtained'],
                            UG_Part2_NoOfAttempts: data['UG_Part2_NoOfAttempts'],
                            UG_Part2_RegisterNo: data['UG_Part2_RegisterNo'],
                            UG_Part2_Passing: data['UG_Part2_Passing'],

                            UG_Part3_SubjectName: data['UG_Part3_SubjectName'],
                            UG_Part3_MarksObtained: data['UG_Part3_MarksObtained'],
                            UG_Part3_MaximumMarks: data['UG_Part3_MaximumMarks'],
                            UG_Part3_Percentage: data['UG_Part3_Percentage'],
                            UG_Part3_ClassObtained: data['UG_Part3_ClassObtained'],
                            UG_Part3_NoOfAttempts: data['UG_Part3_NoOfAttempts'],
                            UG_Part3_RegisterNo: data['UG_Part3_RegisterNo'],
                            UG_Part3_Passing: data['UG_Part3_Passing'],

                            UG_Allied1_SubjectName: data['UG_Allied1_SubjectName'],
                            UG_Allied1_MarksObtained: data['UG_Allied1_MarksObtained'],
                            UG_Allied1_MaximumMarks: data['UG_Allied1_MaximumMarks'],
                            UG_Allied1_Percentage: data['UG_Allied1_Percentage'],
                            UG_Allied1_ClassObtained: data['UG_Allied1_ClassObtained'],
                            UG_Allied1_NoOfAttempts: data['UG_Allied1_NoOfAttempts'],
                            UG_Allied1_RegisterNo: data['UG_Allied1_RegisterNo'],
                            UG_Allied1_Passing: data['UG_Allied1_Passing'],

                            UG_Allied2_SubjectName: data['UG_Allied2_SubjectName'],
                            UG_Allied2_MarksObtained: data['UG_Allied2_MarksObtained'],
                            UG_Allied2_MaximumMarks: data['UG_Allied2_MaximumMarks'],
                            UG_Allied2_Percentage: data['UG_Allied2_Percentage'],
                            UG_Allied2_ClassObtained: data['UG_Allied2_ClassObtained'],
                            UG_Allied2_NoOfAttempts: data['UG_Allied2_NoOfAttempts'],
                            UG_Allied2_RegisterNo: data['UG_Allied2_RegisterNo'],
                            UG_Allied2_Passing: data['UG_Allied2_Passing'],
                            UG_Overall_Main_Core: data['UG_Overall_Main_Core'],
                            UG_Overall_Ancy_Allied: data['UG_Overall_Ancy_Allied'],
                            UG_Overall_Part3: data['UG_Overall_Part3'],

                            PG_courseName: data['PG_courseName'],
                            PG_Part1_SubjectName: data['PG_Part1_SubjectName'],
                            PG_Part1_MarksObtained: data['PG_Part1_MarksObtained'],
                            PG_Part1_MaximumMarks: data['PG_Part1_MaximumMarks'],
                            PG_Part1_Percentage: data['PG_Part1_Percentage'],
                            PG_Part1_ClassObtained: data['PG_Part1_ClassObtained'],
                            PG_Part1_NoOfAttempts: data['PG_Part1_NoOfAttempts'],
                            PG_Part1_RegisterNo: data['PG_Part1_RegisterNo'],
                            PG_Part1_Passing: data['PG_Part1_Passing'],

                            PG_Part2_SubjectName: data['PG_Part2_SubjectName'],
                            PG_Part2_MarksObtained: data['PG_Part2_MarksObtained'],
                            PG_Part2_MaximumMarks: data['PG_Part2_MaximumMarks'],
                            PG_Part2_Percentage: data['PG_Part2_Percentage'],
                            PG_Part2_ClassObtained: data['PG_Part2_ClassObtained'],
                            PG_Part2_NoOfAttempts: data['PG_Part2_NoOfAttempts'],
                            PG_Part2_RegisterNo: data['PG_Part2_RegisterNo'],
                            PG_Part2_Passing: data['PG_Part2_Passing'],

                            PG_Part3_SubjectName: data['PG_Part3_SubjectName'],
                            PG_Part3_MarksObtained: data['PG_Part3_MarksObtained'],
                            PG_Part3_MaximumMarks: data['PG_Part3_MaximumMarks'],
                            PG_Part3_Percentage: data['PG_Part3_Percentage'],
                            PG_Part3_ClassObtained: data['PG_Part3_ClassObtained'],
                            PG_Part3_NoOfAttempts: data['PG_Part3_NoOfAttempts'],
                            PG_Part3_RegisterNo: data['PG_Part3_RegisterNo'],
                            PG_Part3_Passing: data['PG_Part3_Passing'],

                            PG_Allied1_SubjectName: data['PG_Allied1_SubjectName'],
                            PG_Allied1_MarksObtained: data['PG_Allied1_MarksObtained'],
                            PG_Allied1_MaximumMarks: data['PG_Allied1_MaximumMarks'],
                            PG_Allied1_Percentage: data['PG_Allied1_Percentage'],
                            PG_Allied1_ClassObtained: data['PG_Allied1_ClassObtained'],
                            PG_Allied1_NoOfAttempts: data['PG_Allied1_NoOfAttempts'],
                            PG_Allied1_RegisterNo: data['PG_Allied1_RegisterNo'],
                            PG_Allied1_Passing: data['PG_Allied1_Passing'],

                            PG_Allied2_SubjectName: data['PG_Allied2_SubjectName'],
                            PG_Allied2_MarksObtained: data['PG_Allied2_MarksObtained'],
                            PG_Allied2_MaximumMarks: data['PG_Allied2_MaximumMarks'],
                            PG_Allied2_Percentage: data['PG_Allied2_Percentage'],
                            PG_Allied2_ClassObtained: data['PG_Allied2_ClassObtained'],
                            PG_Allied2_NoOfAttempts: data['PG_Allied2_NoOfAttempts'],
                            PG_Allied2_RegisterNo: data['PG_Allied2_RegisterNo'],
                            PG_Allied2_Passing: data['PG_Allied2_Passing'],
                            PG_Overall_Main_Core: data['PG_Overall_Main_Core'],
                            PG_Overall_Ancy_Allied: data['PG_Overall_Ancy_Allied'],
                            PG_Overall_Part3: data['PG_Overall_Part3'],

                            MPhil_courseName: data['MPhil_courseName'],
                            MPhil_Part1_SubjectName: data['MPhil_Part1_SubjectName'],
                            MPhil_Part1_MarksObtained: data['MPhil_Part1_MarksObtained'],
                            MPhil_Part1_MaximumMarks: data['MPhil_Part1_MaximumMarks'],
                            MPhil_Part1_Percentage: data['MPhil_Part1_Percentage'],
                            MPhil_Part1_ClassObtained: data['MPhil_Part1_ClassObtained'],
                            MPhil_Part1_NoOfAttempts: data['MPhil_Part1_NoOfAttempts'],
                            MPhil_Part1_RegisterNo: data['MPhil_Part1_RegisterNo'],
                            MPhil_Part1_Passing: data['MPhil_Part1_Passing'],

                            MPhil_Part2_SubjectName: data['MPhil_Part2_SubjectName'],
                            MPhil_Part2_MarksObtained: data['MPhil_Part2_MarksObtained'],
                            MPhil_Part2_MaximumMarks: data['MPhil_Part2_MaximumMarks'],
                            MPhil_Part2_Percentage: data['MPhil_Part2_Percentage'],
                            MPhil_Part2_ClassObtained: data['MPhil_Part2_ClassObtained'],
                            MPhil_Part2_NoOfAttempts: data['MPhil_Part2_NoOfAttempts'],
                            MPhil_Part2_RegisterNo: data['MPhil_Part2_RegisterNo'],
                            MPhil_Part2_Passing: data['MPhil_Part2_Passing'],

                            MPhil_Part3_SubjectName: data['MPhil_Part3_SubjectName'],
                            MPhil_Part3_MarksObtained: data['MPhil_Part3_MarksObtained'],
                            MPhil_Part3_MaximumMarks: data['MPhil_Part3_MaximumMarks'],
                            MPhil_Part3_Percentage: data['MPhil_Part3_Percentage'],
                            MPhil_Part3_ClassObtained: data['MPhil_Part3_ClassObtained'],
                            MPhil_Part3_NoOfAttempts: data['MPhil_Part3_NoOfAttempts'],
                            MPhil_Part3_RegisterNo: data['MPhil_Part3_RegisterNo'],
                            MPhil_Part3_Passing: data['MPhil_Part3_Passing'],

                            MPhil_Allied1_SubjectName: data['MPhil_Allied1_SubjectName'],
                            MPhil_Allied1_MarksObtained: data['MPhil_Allied1_MarksObtained'],
                            MPhil_Allied1_MaximumMarks: data['MPhil_Allied1_MaximumMarks'],
                            MPhil_Allied1_Percentage: data['MPhil_Allied1_Percentage'],
                            MPhil_Allied1_ClassObtained: data['MPhil_Allied1_ClassObtained'],
                            MPhil_Allied1_NoOfAttempts: data['MPhil_Allied1_NoOfAttempts'],
                            MPhil_Allied1_RegisterNo: data['MPhil_Allied1_RegisterNo'],
                            MPhil_Allied1_Passing: data['MPhil_Allied1_Passing'],

                            MPhil_Allied2_SubjectName: data['MPhil_Allied2_SubjectName'],
                            MPhil_Allied2_MarksObtained: data['MPhil_Allied2_MarksObtained'],
                            MPhil_Allied2_MaximumMarks: data['MPhil_Allied2_MaximumMarks'],
                            MPhil_Allied2_Percentage: data['MPhil_Allied2_Percentage'],
                            MPhil_Allied2_ClassObtained: data['MPhil_Allied2_ClassObtained'],
                            MPhil_Allied2_NoOfAttempts: data['MPhil_Allied2_NoOfAttempts'],
                            MPhil_Allied2_RegisterNo: data['MPhil_Allied2_RegisterNo'],
                            MPhil_Allied2_Passing: data['MPhil_Allied2_Passing'],
                            MPhil_Overall_Main_Core: data['MPhil_Overall_Main_Core'],
                            MPhil_Overall_Ancy_Allied: data['MPhil_Overall_Ancy_Allied'],
                            MPhil_Overall_Part3: data['MPhil_Overall_Part3'],
                        })

                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    toasts(response.data.message, "Error")
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getStudentProfile(studentDetailsId: any) {
        getProfileForStudent(studentDetailsId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.studentProfile;
                    if (data != undefined) {
                        setStudentProfileData(data);
                        for (let i = 0; i < data.length; i++) {
                            data[i].sno = i + 1;
                        }
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    toasts(response.data.message, "Error")
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function onUpload(studentOrStaffDetailsId: any) {
        const filedata = new FormData();
        filedata.append('profilePic', selectedFile, selectedFile.name)
        filedata.append('licenseKey', getLicenseKey.toString())
        filedata.append('userAccountId', userAccountId)
        filedata.append('studentOrStaffDetailsId', studentOrStaffDetailsId)
        filedata.append('userTypeId', "10")

        profilePicUpload(filedata,
            (response) => {
                showLoader(false)
                console.log('Profile pic upload');
                setAlertStatus({ message: response.data.message, type: "success" });
                setIsOpen(true);
                setIsNavigate(-1)
            }
            , (error) => {
                showLoader(false)
                setAlertStatus({ message: 'Profile pic not upload', type: 'error' });
                setIsOpen(true);
                setIsNavigate(null);
            }
        )
    }

    function onUpload1(studentOrStaffDetailsId: any) {
        const filedata = new FormData();
        filedata.append('profilePic', selectedFile, selectedFile.name)
        filedata.append('licenseKey', getLicenseKey.toString())
        filedata.append('userAccountId', userAccountId)
        filedata.append('studentOrStaffDetailsId', studentOrStaffDetailsId)
        filedata.append('userTypeId', "10")

        profilePicUpload(filedata,
            (response) => {
                showLoader(false)
                console.log('Profile pic upload');
                // setAlertStatus({ message: response.data.message, type: "success" });
                // setIsOpen(true);
                // setIsNavigate(`../academic/studentList`)
            }
            , (error) => {
                console.log('Profile pic not upload');
                // showLoader(false)
                // setAlertStatus({ message: 'Profile pic not upload', type: 'error' });
                // setIsOpen(true);
                // setIsNavigate(null);
            }
        )
    }

    function setUpdateStudentDetails() {

        return ({
            ///----General Info----////
            studentDetailsId: updateStudentForm.values.studentDetailsId ? updateStudentForm.values.studentDetailsId : null,
            graduationTypeId: graduationTypeId != "" ? graduationTypeId : null,
            admissionNo: updateStudentForm.values.admissionNo != "" ? updateStudentForm.values.admissionNo : null,
            tempNo: updateStudentForm.values.tempNo != "" ? updateStudentForm.values.tempNo : null,
            firstName: updateStudentForm.values.firstName != "" ? updateStudentForm.values.firstName : null,
            lastName: updateStudentForm.values.lastName != "" ? updateStudentForm.values.lastName : null,
            surName: updateStudentForm.values.surName != "" ? updateStudentForm.values.surName : null,
            studentNameTamil: updateStudentForm.values.studentNameTamil != "" ? updateStudentForm.values.studentNameTamil : null,
            surNameTamil: updateStudentForm.values.surNameTamil != "" ? updateStudentForm.values.surNameTamil : null,
            dateOfBirth: updateStudentForm.values.dateOfBirth != "" ? updateStudentForm.values.dateOfBirth : null,
            genderId: genderId?.value != undefined ? genderId?.value : null,
            bloodGroupId: bloodGroupId?.value != undefined ? bloodGroupId?.value : null,
            motherTongue: motherTongue?.value != undefined ? motherTongue?.value : null,
            nationality: nationality != "" ? nationality : null,
            otherNation: otherNationValue != "" ? otherNationValue : null,
            religionId: religionId?.value != undefined ? religionId?.value : null,
            casteUniqueId: updateStudentForm.values.casteUniqueId != "" ? updateStudentForm.values.casteUniqueId : null,
            casteDetailsId: casteDetailsId?.value != undefined ? casteDetailsId?.value : null,
            subcaste: updateStudentForm.values.subcaste != "" ? updateStudentForm.values.subcaste : null,
            category: category?.value != undefined ? category?.value : null,
            aadharCard: updateStudentForm.values.aadharCard != "" ? updateStudentForm.values.aadharCard : null,
            physicallyChallenged: physicallyChallenged != "" ? physicallyChallenged : null,
            physicallyChallengedType: physicallyChallengedTypeValue != "" ? physicallyChallengedTypeValue : null,
            physicallyChallengedPercentage: physicallyChallengedPercentageValue != "" ? physicallyChallengedPercentageValue : 0,
            martialStatus: updateStudentForm.values.martialStatus != "" ? updateStudentForm.values.martialStatus : null,
            email: updateStudentForm.values.email != "" ? updateStudentForm.values.email : null,
            uniRegNo: updateStudentForm.values.uniRegNo != "" ? updateStudentForm.values.uniRegNo : null,
            emisNo: updateStudentForm.values.emisNo != "" ? updateStudentForm.values.emisNo : null,
            smsToBeSentNumber: updateStudentForm.values.smsToBeSentNumber != "" ? updateStudentForm.values.smsToBeSentNumber : '',
            ///----Address INFO----////

            commAddr_FlatNo: addressForm.values.commAddr_FlatNo != "" ? addressForm.values.commAddr_FlatNo : null,
            commAddr_Street: addressForm.values.commAddr_Street != "" ? addressForm.values.commAddr_Street : null,
            commAddr_Area: addressForm.values.commAddr_Area != "" ? addressForm.values.commAddr_Area : null,
            commAddr_StateId: commAddr_StateId?.value != undefined ? commAddr_StateId?.value : null,
            commAddr_CityId: commAddr_CityId?.value != undefined ? commAddr_CityId?.value : null,
            commAddr_Pincode: addressForm.values.commAddr_Pincode != "" ? addressForm.values.commAddr_Pincode : null,

            permAddr_FlatNo: permAddr_FlatNo != "" ? permAddr_FlatNo : null,
            permAddr_Street: permAddr_Street != "" ? permAddr_Street : null,
            permAddr_Area: permAddr_Area != "" ? permAddr_Area : null,
            permAddr_StateId: permAddr_StateId?.value != undefined ? permAddr_StateId?.value : null,
            permAddr_CityId: permAddr_CityId?.value != undefined ? permAddr_CityId?.value : null,
            permAddr_Pincode: permAddr_Pincode != "" ? permAddr_Pincode : null,

            bankName: addressForm.values.bankName != "" ? addressForm.values.bankName : null,
            bankAccountNo: addressForm.values.bankAccountNo != "" ? addressForm.values.bankAccountNo : null,
            branch: addressForm.values.branch != "" ? addressForm.values.branch : null,
            ifscCode: addressForm.values.ifscCode != "" ? addressForm.values.ifscCode : null,
            micrCode: addressForm.values.micrCode != "" ? addressForm.values.micrCode : null,

            // ///----Class INFO----////

            departmentId: departmentId != "" ? departmentId : null,
            courseId: courseId != "" ? courseId : null,
            batchMasterId: batchMasterId != "" ? batchMasterId : null,
            semesterDetailsId: semesterDetailsId != "" ? semesterDetailsId : null,
            sectionDetailsId: sectionDetailsId?.value != undefined ? sectionDetailsId?.value : null,
            studentRollNo: classForm.values.studentRollNo != "" ? classForm.values.studentRollNo : null,
            admissionDateStamp: classForm.values.admissionDateStamp != "" ? classForm.values.admissionDateStamp : null,
            sourceName: classForm.values.sourceName != "" ? classForm.values.sourceName : null,
            transferCourseId: transferCourseId?.value != undefined ? transferCourseId?.value : null,
            referralTypeId: referralTypeId?.value != undefined ? referralTypeId?.value : null,
            referredId: referredId?.value != undefined ? referredId?.value : null,
            referredName: referredName != "" ? referredName : null,
            interimCollegeTransfer: interimCollegeTransfer != "" ? interimCollegeTransfer : null,
            collegeName: collegeNameValue != "" ? collegeNameValue : null,
            concessionTypeId: concessionTypeId?.value != undefined ? concessionTypeId?.value : null,
            concessionRemarks: concessionRemarks != "" ? concessionRemarks : null,
            transportAreaMasterId: transportAreaValue != "" ? transportAreaValue : null,
            modeOfWays: modeValue ? modeValue != "" : null,
            isCollegeTransport: isCollegeTransport != "" ? isCollegeTransport : null,

            ///----Family INFO----////

            fatherName: familyForm.values.fatherName != "" ? familyForm.values.fatherName : null,
            father_AdharNumber: familyForm.values.father_AdharNumber != "" ? familyForm.values.father_AdharNumber : null,
            fatherOccupation: familyForm.values.fatherOccupation != "" ? familyForm.values.fatherOccupation : null,
            natureofJoborBusiness: familyForm.values.natureofJoborBusiness != "" ? familyForm.values.natureofJoborBusiness : null,
            fatherContactNumber: familyForm.values.fatherContactNumber != "" ? familyForm.values.fatherContactNumber : null,
            fatherEmailId: familyForm.values.fatherEmailId != "" ? familyForm.values.fatherEmailId : null,
            motherName: familyForm.values.motherName != "" ? familyForm.values.motherName : null,
            mother_AdharNumber: familyForm.values.mother_AdharNumber != "" ? familyForm.values.mother_AdharNumber : null,
            yearlyIncome: familyForm.values.yearlyIncome != "" ? familyForm.values.yearlyIncome : null,
            positionHeld: familyForm.values.positionHeld != "" ? familyForm.values.positionHeld : null,
            motherContactNumber: familyForm.values.motherContactNumber != "" ? familyForm.values.motherContactNumber : null,
            guardian_Name: familyForm.values.guardian_Name != "" ? familyForm.values.guardian_Name : null,
            guardian_email: familyForm.values.guardian_email != "" ? familyForm.values.guardian_email : null,
            guardian_phone: familyForm.values.guardian_phone != "" ? familyForm.values.guardian_phone : null,
            guardian_AdharNumber: familyForm.values.guardian_AdharNumber != "" ? familyForm.values.guardian_AdharNumber : null,
            isGuardian: isGuardian ? 1 : 0,

            // // ///----MARK INFO----////
            registerNo_X: markForm.values.registerNo_X ? markForm.values.registerNo_X : null,
            institutionNameAndAddress_X: markForm.values.institutionNameAndAddress_X ? markForm.values.institutionNameAndAddress_X : null,
            boardName_X: markForm.values.boardName_X ? markForm.values.boardName_X : null,
            mediumOfInstitution_X: markForm.values.mediumOfInstitution_X ? markForm.values.mediumOfInstitution_X : null,
            monthAndYearOfPassing_X: markForm.values.monthAndYearOfPassing_X ? markForm.values.monthAndYearOfPassing_X : null,

            registerNo_XI: markForm.values.registerNo_XI ? markForm.values.registerNo_X : null,
            institutionNameAndAddress_XI: markForm.values.institutionNameAndAddress_XI ? markForm.values.institutionNameAndAddress_XI : null,
            boardName_XI: markForm.values.boardName_XI ? markForm.values.boardName_XI : null,
            mediumOfInstitution_XI: markForm.values.mediumOfInstitution_XI ? markForm.values.mediumOfInstitution_XI : null,
            monthAndYearOfPassing_XI: markForm.values.monthAndYearOfPassing_XI ? markForm.values.monthAndYearOfPassing_XI : null,

            registerNo_XII: markForm.values.registerNo_XII ? markForm.values.registerNo_XII : null,
            XIISchoolNameId: XIISchoolNameId?.value != undefined ? XIISchoolNameId?.value : null,
            boardName_XII: markForm.values.boardName_XII ? markForm.values.boardName_XII : null,
            mediumOfInstitution_XII: markForm.values.mediumOfInstitution_XII ? markForm.values.mediumOfInstitution_XII : null,
            monthAndYearOfPassing_XII: markForm.values.monthAndYearOfPassing_XII ? markForm.values.monthAndYearOfPassing_XII : null,

            XI_S1_studentSchoolSubject: XI_S1_studentSchoolSubject?.value != undefined ? XI_S1_studentSchoolSubject?.value : null,
            XI_S1_markSecured: markForm.values.XI_S1_markSecured,
            XI_S1_maximumMarks: markForm.values.XI_S1_maximumMarks,
            XI_S1_monthAndYearOfPassing: markForm.values.XI_S1_monthAndYearOfPassing,
            XI_S1_registerNo: markForm.values.XI_S1_registerNo,
            XI_S1_noOfAttempts: markForm.values.XI_S1_noOfAttempts,
            XI_S2_studentSchoolSubject: XI_S2_studentSchoolSubject?.value != undefined ? XI_S2_studentSchoolSubject?.value : null,
            XI_S2_markSecured: markForm.values.XI_S2_markSecured,
            XI_S2_maximumMarks: markForm.values.XI_S2_maximumMarks,
            XI_S2_monthAndYearOfPassing: markForm.values.XI_S2_monthAndYearOfPassing,
            XI_S2_registerNo: markForm.values.XI_S2_registerNo,
            XI_S2_noOfAttempts: markForm.values.XI_S2_noOfAttempts,
            XI_S3_studentSchoolSubject: XI_S3_studentSchoolSubject?.value != undefined ? XI_S3_studentSchoolSubject?.value : null,
            XI_S3_markSecured: markForm.values.XI_S3_markSecured,
            XI_S3_maximumMarks: markForm.values.XI_S3_maximumMarks,
            XI_S3_monthAndYearOfPassing: markForm.values.XI_S3_monthAndYearOfPassing,
            XI_S3_registerNo: markForm.values.XI_S3_registerNo,
            XI_S3_noOfAttempts: markForm.values.XI_S3_noOfAttempts,
            XI_S4_studentSchoolSubject: XI_S4_studentSchoolSubject?.value != undefined ? XI_S4_studentSchoolSubject?.value : null,
            XI_S4_markSecured: markForm.values.XI_S4_markSecured,
            XI_S4_maximumMarks: markForm.values.XI_S4_maximumMarks,
            XI_S4_monthAndYearOfPassing: markForm.values.XI_S4_monthAndYearOfPassing,
            XI_S4_registerNo: markForm.values.XI_S4_registerNo,
            XI_S4_noOfAttempts: markForm.values.XI_S4_noOfAttempts,
            XI_S5_studentSchoolSubject: XI_S5_studentSchoolSubject?.value != undefined ? XI_S5_studentSchoolSubject?.value : null,
            XI_S5_markSecured: markForm.values.XI_S5_markSecured,
            XI_S5_maximumMarks: markForm.values.XI_S5_maximumMarks,
            XI_S5_monthAndYearOfPassing: markForm.values.XI_S5_monthAndYearOfPassing,
            XI_S5_registerNo: markForm.values.XI_S5_registerNo,
            XI_S5_noOfAttempts: markForm.values.XI_S5_noOfAttempts,
            XI_S6_studentSchoolSubject: XI_S6_studentSchoolSubject?.value != undefined ? XI_S6_studentSchoolSubject?.value : null,
            XI_S6_markSecured: markForm.values.XI_S6_markSecured,
            XI_S6_maximumMarks: markForm.values.XI_S6_maximumMarks,
            XI_S6_monthAndYearOfPassing: markForm.values.XI_S6_monthAndYearOfPassing,
            XI_S6_registerNo: markForm.values.XI_S6_registerNo,
            XI_S6_noOfAttempts: markForm.values.XI_S6_noOfAttempts,

            XII_S1_studentSchoolSubject: XII_S1_studentSchoolSubject?.value != undefined ? XII_S1_studentSchoolSubject?.value : null,
            XII_S1_markSecured: markForm.values.XII_S1_markSecured,
            XII_S1_maximumMarks: markForm.values.XII_S1_maximumMarks,
            XII_S1_monthAndYearOfPassing: markForm.values.XII_S1_monthAndYearOfPassing,
            XII_S1_registerNo: markForm.values.XII_S1_registerNo,
            XII_S1_noOfAttempts: markForm.values.XII_S1_noOfAttempts,
            XII_S2_studentSchoolSubject: XII_S2_studentSchoolSubject?.value != undefined ? XII_S2_studentSchoolSubject?.value : null,
            XII_S2_markSecured: markForm.values.XII_S2_markSecured,
            XII_S2_maximumMarks: markForm.values.XII_S2_maximumMarks,
            XII_S2_monthAndYearOfPassing: markForm.values.XII_S2_monthAndYearOfPassing,
            XII_S2_registerNo: markForm.values.XII_S2_registerNo,
            XII_S2_noOfAttempts: markForm.values.XII_S2_noOfAttempts,
            XII_S3_studentSchoolSubject: XII_S3_studentSchoolSubject?.value != undefined ? XII_S3_studentSchoolSubject?.value : null,
            XII_S3_markSecured: markForm.values.XII_S3_markSecured,
            XII_S3_maximumMarks: markForm.values.XII_S3_maximumMarks,
            XII_S3_monthAndYearOfPassing: markForm.values.XII_S3_monthAndYearOfPassing,
            XII_S3_registerNo: markForm.values.XII_S3_registerNo,
            XII_S3_noOfAttempts: markForm.values.XII_S3_noOfAttempts,
            XII_S4_studentSchoolSubject: XII_S4_studentSchoolSubject?.value != undefined ? XII_S4_studentSchoolSubject?.value : null,
            XII_S4_markSecured: markForm.values.XII_S4_markSecured,
            XII_S4_maximumMarks: markForm.values.XII_S4_maximumMarks,
            XII_S4_monthAndYearOfPassing: markForm.values.XII_S4_monthAndYearOfPassing,
            XII_S4_registerNo: markForm.values.XII_S4_registerNo,
            XII_S4_noOfAttempts: markForm.values.XII_S4_noOfAttempts,
            XII_S5_studentSchoolSubject: XII_S5_studentSchoolSubject?.value != undefined ? XII_S5_studentSchoolSubject?.value : null,
            XII_S5_markSecured: markForm.values.XII_S5_markSecured,
            XII_S5_maximumMarks: markForm.values.XII_S5_maximumMarks,
            XII_S5_monthAndYearOfPassing: markForm.values.XII_S5_monthAndYearOfPassing,
            XII_S5_registerNo: markForm.values.XII_S5_registerNo,
            XII_S5_noOfAttempts: markForm.values.XII_S5_noOfAttempts,
            XII_S6_studentSchoolSubject: XII_S6_studentSchoolSubject?.value != undefined ? XII_S6_studentSchoolSubject?.value : null,
            XII_S6_markSecured: markForm.values.XII_S6_markSecured,
            XII_S6_maximumMarks: markForm.values.XII_S6_maximumMarks,
            XII_S6_monthAndYearOfPassing: markForm.values.XII_S6_monthAndYearOfPassing,
            XII_S6_registerNo: markForm.values.XII_S6_registerNo,
            XII_S6_noOfAttempts: markForm.values.XII_S6_noOfAttempts,

            XI_OverAll_markSecured: markForm.values.XI_OverAll_markSecured,
            XI_OverAll_maximumMarks: markForm.values.XI_OverAll_maximumMarks,
            XII_OverAll_markSecured: markForm.values.XII_OverAll_markSecured,
            XII_OverAll_maximumMarks: markForm.values.XII_OverAll_maximumMarks,

            registerNo_UG: markForm.values.registerNo_UG ? markForm.values.registerNo_UG : null,
            institutionNameAndAddress_UG: markForm.values.institutionNameAndAddress_UG ? markForm.values.institutionNameAndAddress_UG : null,
            universityName_UG: markForm.values.universityName_UG ? markForm.values.universityName_UG : null,
            mediumOfInstitution_UG: markForm.values.mediumOfInstitution_UG ? markForm.values.mediumOfInstitution_UG : null,
            monthAndYearOfPassing_UG: markForm.values.monthAndYearOfPassing_UG ? markForm.values.monthAndYearOfPassing_UG : null,

            registerNo_PG: markForm.values.registerNo_PG ? markForm.values.registerNo_PG : null,
            institutionNameAndAddress_PG: markForm.values.institutionNameAndAddress_PG ? markForm.values.institutionNameAndAddress_PG : null,
            universityName_PG: markForm.values.universityName_PG ? markForm.values.universityName_PG : null,
            mediumOfInstitution_PG: markForm.values.mediumOfInstitution_PG ? markForm.values.mediumOfInstitution_PG : null,
            monthAndYearOfPassing_PG: markForm.values.monthAndYearOfPassing_PG ? markForm.values.monthAndYearOfPassing_PG : null,

            registerNo_MPhil: markForm.values.registerNo_MPhil ? markForm.values.registerNo_MPhil : null,
            institutionNameAndAddress_MPhil: markForm.values.institutionNameAndAddress_MPhil ? markForm.values.institutionNameAndAddress_MPhil : null,
            universityName_MPhil: markForm.values.universityName_MPhil ? markForm.values.universityName_MPhil : null,
            mediumOfInstitution_MPhil: markForm.values.mediumOfInstitution_MPhil ? markForm.values.mediumOfInstitution_MPhil : null,
            monthAndYearOfPassing_MPhil: markForm.values.monthAndYearOfPassing_MPhil ? markForm.values.monthAndYearOfPassing_MPhil : null,

            UG_courseName: markForm.values.UG_courseName ? markForm.values.UG_courseName : null,
            UG_Part1_SubjectName: markForm.values.UG_Part1_SubjectName ? markForm.values.UG_Part1_SubjectName : null,
            UG_Part1_MarksObtained: markForm.values.UG_Part1_MarksObtained,
            UG_Part1_MaximumMarks: markForm.values.UG_Part1_MaximumMarks,
            UG_Part1_Percentage: markForm.values.UG_Part1_Percentage,
            UG_Part1_ClassObtained: markForm.values.UG_Part1_ClassObtained,
            UG_Part1_NoOfAttempts: markForm.values.UG_Part1_NoOfAttempts,
            UG_Part1_RegisterNo: markForm.values.UG_Part1_RegisterNo,
            UG_Part1_Passing: markForm.values.UG_Part1_Passing,

            UG_Part2_SubjectName: markForm.values.UG_Part2_SubjectName ? markForm.values.UG_Part2_SubjectName : null,
            UG_Part2_MarksObtained: markForm.values.UG_Part2_MarksObtained,
            UG_Part2_MaximumMarks: markForm.values.UG_Part2_MaximumMarks,
            UG_Part2_Percentage: markForm.values.UG_Part2_Percentage,
            UG_Part2_ClassObtained: markForm.values.UG_Part2_ClassObtained,
            UG_Part2_NoOfAttempts: markForm.values.UG_Part2_NoOfAttempts,
            UG_Part2_RegisterNo: markForm.values.UG_Part2_RegisterNo,
            UG_Part2_Passing: markForm.values.UG_Part2_Passing,

            UG_Part3_SubjectName: markForm.values.UG_Part3_SubjectName ? markForm.values.UG_Part3_SubjectName : null,
            UG_Part3_MarksObtained: markForm.values.UG_Part3_MarksObtained,
            UG_Part3_MaximumMarks: markForm.values.UG_Part3_MaximumMarks,
            UG_Part3_Percentage: markForm.values.UG_Part3_Percentage,
            UG_Part3_ClassObtained: markForm.values.UG_Part3_ClassObtained,
            UG_Part3_NoOfAttempts: markForm.values.UG_Part3_NoOfAttempts,
            UG_Part3_RegisterNo: markForm.values.UG_Part3_RegisterNo,
            UG_Part3_Passing: markForm.values.UG_Part3_Passing,

            UG_Allied1_SubjectName: markForm.values.UG_Allied1_SubjectName ? markForm.values.UG_Allied1_SubjectName : null,
            UG_Allied1_MarksObtained: markForm.values.UG_Allied1_MarksObtained,
            UG_Allied1_MaximumMarks: markForm.values.UG_Allied1_MaximumMarks,
            UG_Allied1_Percentage: markForm.values.UG_Allied1_Percentage,
            UG_Allied1_ClassObtained: markForm.values.UG_Allied1_ClassObtained,
            UG_Allied1_NoOfAttempts: markForm.values.UG_Allied1_NoOfAttempts,
            UG_Allied1_RegisterNo: markForm.values.UG_Allied1_RegisterNo,
            UG_Allied1_Passing: markForm.values.UG_Allied1_Passing,

            UG_Allied2_SubjectName: markForm.values.UG_Allied2_SubjectName ? markForm.values.UG_Allied2_SubjectName : null,
            UG_Allied2_MarksObtained: markForm.values.UG_Allied2_MarksObtained,
            UG_Allied2_MaximumMarks: markForm.values.UG_Allied2_MaximumMarks,
            UG_Allied2_Percentage: markForm.values.UG_Allied2_Percentage,
            UG_Allied2_ClassObtained: markForm.values.UG_Allied2_ClassObtained,
            UG_Allied2_NoOfAttempts: markForm.values.UG_Allied2_NoOfAttempts,
            UG_Allied2_RegisterNo: markForm.values.UG_Allied2_RegisterNo,
            UG_Allied2_Passing: markForm.values.UG_Allied2_Passing,
            UG_Overall_Main_Core: markForm.values.UG_Overall_Main_Core,
            UG_Overall_Ancy_Allied: markForm.values.UG_Overall_Ancy_Allied,
            UG_Overall_Part3: markForm.values.UG_Overall_Part3,

            PG_courseName: markForm.values.PG_courseName ? markForm.values.PG_courseName : null,
            PG_Part1_SubjectName: markForm.values.PG_Part1_SubjectName ? markForm.values.PG_Part1_SubjectName : null,
            PG_Part1_MarksObtained: markForm.values.PG_Part1_MarksObtained,
            PG_Part1_MaximumMarks: markForm.values.PG_Part1_MaximumMarks,
            PG_Part1_Percentage: markForm.values.PG_Part1_Percentage,
            PG_Part1_ClassObtained: markForm.values.PG_Part1_ClassObtained,
            PG_Part1_NoOfAttempts: markForm.values.PG_Part1_NoOfAttempts,
            PG_Part1_RegisterNo: markForm.values.PG_Part1_RegisterNo,
            PG_Part1_Passing: markForm.values.PG_Part1_Passing,

            PG_Part2_SubjectName: markForm.values.PG_Part2_SubjectName ? markForm.values.PG_Part2_SubjectName : null,
            PG_Part2_MarksObtained: markForm.values.PG_Part2_MarksObtained,
            PG_Part2_MaximumMarks: markForm.values.PG_Part2_MaximumMarks,
            PG_Part2_Percentage: markForm.values.PG_Part2_Percentage,
            PG_Part2_ClassObtained: markForm.values.PG_Part2_ClassObtained,
            PG_Part2_NoOfAttempts: markForm.values.PG_Part2_NoOfAttempts,
            PG_Part2_RegisterNo: markForm.values.PG_Part2_RegisterNo,
            PG_Part2_Passing: markForm.values.PG_Part2_Passing,

            PG_Part3_SubjectName: markForm.values.PG_Part3_SubjectName ? markForm.values.PG_Part3_SubjectName : null,
            PG_Part3_MarksObtained: markForm.values.PG_Part3_MarksObtained,
            PG_Part3_MaximumMarks: markForm.values.PG_Part3_MaximumMarks,
            PG_Part3_Percentage: markForm.values.PG_Part3_Percentage,
            PG_Part3_ClassObtained: markForm.values.PG_Part3_ClassObtained,
            PG_Part3_NoOfAttempts: markForm.values.PG_Part3_NoOfAttempts,
            PG_Part3_RegisterNo: markForm.values.PG_Part3_RegisterNo,
            PG_Part3_Passing: markForm.values.PG_Part3_Passing,

            PG_Allied1_SubjectName: markForm.values.PG_Allied1_SubjectName ? markForm.values.PG_Allied1_SubjectName : null,
            PG_Allied1_MarksObtained: markForm.values.PG_Allied1_MarksObtained,
            PG_Allied1_MaximumMarks: markForm.values.PG_Allied1_MaximumMarks,
            PG_Allied1_Percentage: markForm.values.PG_Allied1_Percentage,
            PG_Allied1_ClassObtained: markForm.values.PG_Allied1_ClassObtained,
            PG_Allied1_NoOfAttempts: markForm.values.PG_Allied1_NoOfAttempts,
            PG_Allied1_RegisterNo: markForm.values.PG_Allied1_RegisterNo,
            PG_Allied1_Passing: markForm.values.PG_Allied1_Passing,

            PG_Allied2_SubjectName: markForm.values.PG_Allied2_SubjectName ? markForm.values.PG_Allied2_SubjectName : null,
            PG_Allied2_MarksObtained: markForm.values.PG_Allied2_MarksObtained,
            PG_Allied2_MaximumMarks: markForm.values.PG_Allied2_MaximumMarks,
            PG_Allied2_Percentage: markForm.values.PG_Allied2_Percentage,
            PG_Allied2_ClassObtained: markForm.values.PG_Allied2_ClassObtained,
            PG_Allied2_NoOfAttempts: markForm.values.PG_Allied2_NoOfAttempts,
            PG_Allied2_RegisterNo: markForm.values.PG_Allied2_RegisterNo,
            PG_Allied2_Passing: markForm.values.PG_Allied2_Passing,
            PG_Overall_Main_Core: markForm.values.PG_Overall_Main_Core,
            PG_Overall_Ancy_Allied: markForm.values.PG_Overall_Ancy_Allied,
            PG_Overall_Part3: markForm.values.PG_Overall_Part3,

            MPhil_courseName: markForm.values.MPhil_courseName ? markForm.values.MPhil_courseName : null,
            MPhil_Part1_SubjectName: markForm.values.MPhil_Part1_SubjectName ? markForm.values.MPhil_Part1_SubjectName : null,
            MPhil_Part1_MarksObtained: markForm.values.MPhil_Part1_MarksObtained,
            MPhil_Part1_MaximumMarks: markForm.values.MPhil_Part1_MaximumMarks,
            MPhil_Part1_Percentage: markForm.values.MPhil_Part1_Percentage,
            MPhil_Part1_ClassObtained: markForm.values.MPhil_Part1_ClassObtained,
            MPhil_Part1_NoOfAttempts: markForm.values.MPhil_Part1_NoOfAttempts,
            MPhil_Part1_RegisterNo: markForm.values.MPhil_Part1_RegisterNo,
            MPhil_Part1_Passing: markForm.values.MPhil_Part1_Passing,

            MPhil_Part2_SubjectName: markForm.values.MPhil_Part2_SubjectName ? markForm.values.MPhil_Part2_SubjectName : null,
            MPhil_Part2_MarksObtained: markForm.values.MPhil_Part2_MarksObtained,
            MPhil_Part2_MaximumMarks: markForm.values.MPhil_Part2_MaximumMarks,
            MPhil_Part2_Percentage: markForm.values.MPhil_Part2_Percentage,
            MPhil_Part2_ClassObtained: markForm.values.MPhil_Part2_ClassObtained,
            MPhil_Part2_NoOfAttempts: markForm.values.MPhil_Part2_NoOfAttempts,
            MPhil_Part2_RegisterNo: markForm.values.MPhil_Part2_RegisterNo,
            MPhil_Part2_Passing: markForm.values.MPhil_Part2_Passing,

            MPhil_Part3_SubjectName: markForm.values.MPhil_Part3_SubjectName ? markForm.values.MPhil_Part3_SubjectName : null,
            MPhil_Part3_MarksObtained: markForm.values.MPhil_Part3_MarksObtained,
            MPhil_Part3_MaximumMarks: markForm.values.MPhil_Part3_MaximumMarks,
            MPhil_Part3_Percentage: markForm.values.MPhil_Part3_Percentage,
            MPhil_Part3_ClassObtained: markForm.values.MPhil_Part3_ClassObtained,
            MPhil_Part3_NoOfAttempts: markForm.values.MPhil_Part3_NoOfAttempts,
            MPhil_Part3_RegisterNo: markForm.values.MPhil_Part3_RegisterNo,
            MPhil_Part3_Passing: markForm.values.MPhil_Part3_Passing,

            MPhil_Allied1_SubjectName: markForm.values.MPhil_Allied1_SubjectName ? markForm.values.MPhil_Allied1_SubjectName : null,
            MPhil_Allied1_MarksObtained: markForm.values.MPhil_Allied1_MarksObtained,
            MPhil_Allied1_MaximumMarks: markForm.values.MPhil_Allied1_MaximumMarks,
            MPhil_Allied1_Percentage: markForm.values.MPhil_Allied1_Percentage,
            MPhil_Allied1_ClassObtained: markForm.values.MPhil_Allied1_ClassObtained,
            MPhil_Allied1_NoOfAttempts: markForm.values.MPhil_Allied1_NoOfAttempts,
            MPhil_Allied1_RegisterNo: markForm.values.MPhil_Allied1_RegisterNo,
            MPhil_Allied1_Passing: markForm.values.MPhil_Allied1_Passing,

            MPhil_Allied2_SubjectName: markForm.values.MPhil_Allied2_SubjectName ? markForm.values.MPhil_Allied2_SubjectName : null,
            MPhil_Allied2_MarksObtained: markForm.values.MPhil_Allied2_MarksObtained,
            MPhil_Allied2_MaximumMarks: markForm.values.MPhil_Allied2_MaximumMarks,
            MPhil_Allied2_Percentage: markForm.values.MPhil_Allied2_Percentage,
            MPhil_Allied2_ClassObtained: markForm.values.MPhil_Allied2_ClassObtained,
            MPhil_Allied2_NoOfAttempts: markForm.values.MPhil_Allied2_NoOfAttempts,
            MPhil_Allied2_RegisterNo: markForm.values.MPhil_Allied2_RegisterNo,
            MPhil_Allied2_Passing: markForm.values.MPhil_Allied2_Passing,
            MPhil_Overall_Main_Core: markForm.values.MPhil_Overall_Main_Core,
            MPhil_Overall_Ancy_Allied: markForm.values.MPhil_Overall_Ancy_Allied,
            MPhil_Overall_Part3: markForm.values.MPhil_Overall_Part3,

            licenseKey: getLicenseKey,
            userAccountId: userAccountId,
        })
    }

    function updateStudentDetailsSubmit() {
        showLoader(true)
        if (updateStudentForm.isValid) {
            let updateStudentDetailsPostData = setUpdateStudentDetails()
            updateStudentDetails(updateStudentDetailsPostData,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "success" });
                        setIsOpen(true);
                        setIsNavigate(-1)
                        if (selectedFile != undefined) {
                            onUpload1(studentDetailsId);
                        }
                        updateStudentForm.resetForm();
                    }
                    else if (data.success == false) {
                        if (selectedFile != undefined) {
                            onUpload(studentDetailsId);
                        } else {
                            showLoader(false)
                            setAlertStatus({ message: data.message, type: "error" });
                            setIsOpen(true);
                            setIsNavigate(null);
                        }
                    }
                    else {
                        showLoader(false)
                        let errorCode = response.data.error[0].error_code;
                        let errorDescription = response.data.error[0].error_description;
                        setAlertStatus({ message: errorDescription, type: "error" });
                        setIsOpen(true);
                        setIsNavigate(null);
                    }
                }, (error) => {
                    showLoader(false)
                    setAlertStatus({ message: error, type: "error" });
                    setIsOpen(true);
                    setIsNavigate(null);
                }
            )
        } else if (updateStudentForm.isValid == false) {
            showLoader(false)
            setAlertStatus({ message: 'Please fill all the details!', type: "error" });
            setIsOpen(true);
            setIsNavigate(null);
        }
    }

    const selectNationality = (e: any) => {
        let nationality = e.target.value
        setIsNationality(nationality)
        if (nationality == 'Others') {
            setIsOtherNation('Other')
        }
        else {
            setIsOtherNation('isOthers')
            setOtherNationValue('')
        }
    }
   
    const selectPhysicallyChallenged = (e: any) => {
        let physicallyChallenged = e.target.value
        setPhysicallyChallenged(physicallyChallenged)
        if (physicallyChallenged == 'Yes') {
            setIsPhysicallyChallengedDetails('YES')
        }
        else {
            setIsPhysicallyChallengedDetails('isPhysicallyChallengedDetails')
            setPhysicallyChallengedPercentageValue('')
            setPhysicallyChallengedTypeValue('')
        }
    }
 
    const selectInterimCollegeTransfer = (e: any) => {
        setCollegeNameValue('')
        let interimCollegeTransfer = e.target.value
        setIsInterimCollegeTransfer(interimCollegeTransfer)
    }

    const handleCheckboxChange = (e: any) => {
        setIsGuardian(e.target.checked);
    };
    
    function address(e: any) {
        setIsChecked(e.target.checked)

        if (e.target.checked == true) {
            setPermAddr_FlatNo(addressForm.values.commAddr_FlatNo)
            setPermAddr_Street(addressForm.values.commAddr_Street)
            setPermAddr_Area(addressForm.values.commAddr_Area)
            setPermAddr_Pincode(addressForm.values.commAddr_Pincode)
            setPermAddr_StateId(commAddr_StateId)
            setPermAddr_CityId(commAddr_CityId)

            if (commAddr_StateId?.value != undefined) {
                getPermAddr_StateAndCity(commAddr_StateId?.value)
            }
        }
        else {
            setPermAddr_FlatNo('')
            setPermAddr_Street('')
            setPermAddr_Area('')
            setPermAddr_Pincode('')
            setPermAddr_StateId('')
            setPermAddr_CityId('')
        }
    }

    const titles = [
        'General Info',
        'Address Info',
        'Class Info',
        'Family Info',
        'Mark Info',
        'Certificate Info',
        'Admission Info'
    ];

    const handleFileChange = (e: any) => {
        if (e.target.files && e.target.files[0]) {
            setSelectedFile(e.target.files[0]);
        }
    };

    const handleDeleteAvatar = () => {
        setSelectedFile(null);
        const fileInput = document.getElementById('fileInput') as HTMLInputElement;
        if (fileInput) {
            fileInput.value = '';
        }
    };
    return (
        <>
            <PageWrapper title="Update Student">
                <SubHeader>
                    <SubHeaderLeft>
                        <Button color='info' isLink icon='ArrowBack' onClick={() => navigate(-1)}>
                            Back to List
                        </Button>
                        <SubheaderSeparator />
                        {studentProfileData.map((student: any, index: any) => (
                            <div key={index}>
                                <img style={{ borderRadius: '50%' }}
                                    src={student.profilePath != null ? student.profilePath : profilePic(studentProfileData.genderId)}
                                    height='40' width='40' onError={(e: any) => pictNotLoading(e, studentProfileData.genderId)}
                                />
                                <span>
                                    <strong className='ms-3'>{student.studentName} </strong>
                                </span>
                                <span className='border border-success border-2 text-success fw-bold px-3 py-2 rounded'>
                                    {student.admissionNo}
                                </span>
                            </div>))}
                    </SubHeaderLeft>
                </SubHeader>
                <Page container='fluid'>
                    <Card>
                        <CardHeader>
                            <CardLabel icon="Assignment" color="info">
                                {[...Array(totalSteps)].map((_, index) => (
                                    <CardTitle
                                        key={index}
                                        className={index !== step ? 'd-none' : undefined}
                                    >{titles[step]}
                                    </CardTitle>
                                ))}
                            </CardLabel>
                        </CardHeader>
                        <CardBody>
                            <div className='wizard-progress position-relative'>
                                <div className='progress'>
                                    <div
                                        className='progress-bar bg-primary'
                                        role='progressbar'
                                        style={{ width: `${(100 / (totalSteps - 1)) * step}%` }}
                                        aria-valuenow={(100 / (totalSteps - 1)) * step}
                                        aria-valuemin={0}
                                        aria-valuemax={100}
                                        aria-label='progress'
                                    />
                                </div>
                                {[...Array(totalSteps)].map((child: any, index: any) => (
                                    <Popovers
                                        key={index}
                                        desc={titles[index]}
                                        trigger='hover'>
                                        <button
                                            type='button'
                                            className={classNames(
                                                'wizard-progress-btn',
                                                'position-absolute p-0 top-0',
                                                'translate-middle',
                                                'btn btn-sm',
                                                {
                                                    [`btn-primary`]: step >= index,
                                                    [`btn-${themeStatus}`]: step < index,
                                                },
                                                'rounded-pill',
                                            )}
                                            style={{
                                                left: `${(100 / (totalSteps - 1)) * index}%`,
                                            }}
                                            onClick={() => { handleStepClick(index) }}>
                                            {index + 1}
                                        </button>
                                    </Popovers>
                                ))}
                            </div>
                            {step == 0 && (
                                <Card shadow='none' title="GeneralInfo" stretch>
                                    <form noValidate onSubmit={updateStudentForm.handleSubmit}>
                                        <div className="row g-4">
                                            <div className='col-12'>
                                                <div className='row g-4 align-items-center'>
                                                    <div className="col-6 g-4">
                                                        <div className="col-lg-12">
                                                            <FormGroup id='graduationTypeId' label='Graduation Type' isFloating>
                                                                <Select
                                                                    ariaLabel='Graduation Type'
                                                                    onChange={selectGraduationType}
                                                                    value={graduationTypeId}
                                                                    list={graduationTypeData.map((data: any) => (
                                                                        { value: data.graduationTypeId, text: data.graduationType }
                                                                    ))}
                                                                    onBlur={updateStudentForm.handleBlur}
                                                                    isValid={updateStudentForm.isValid}
                                                                    isTouched={updateStudentForm.touched.graduationTypeId}
                                                                    invalidFeedback={updateStudentForm.errors.graduationTypeId} disabled />
                                                            </FormGroup>
                                                        </div>
                                                        <div className="col-lg-12 mt-3">
                                                            <FormGroup id="tempNo" label="Temp No" isFloating>
                                                                <Input type="text" placeholder="Select Temp No"
                                                                    onChange={updateStudentForm.handleChange}
                                                                    value={updateStudentForm.values.tempNo}
                                                                    disabled />
                                                            </FormGroup>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className='col-12'>
                                                            <div className='row g-4 align-items-center'>
                                                                <div className='col-lg-auto'>
                                                                    {selectedFile ?
                                                                        <img style={{ borderRadius: '50%' }}
                                                                            src={URL.createObjectURL(selectedFile)}
                                                                            height='130' width='130' />
                                                                        :
                                                                        <img style={{ borderRadius: '50%' }}
                                                                            src={profilePath != null ? profilePath : profilePic(studentProfileData.genderId)}
                                                                            height='130' width='130' onError={(e: any) => pictNotLoading(e, studentProfileData.genderId)}
                                                                        />}
                                                                </div>
                                                                <div className='col-lg mt-3'>
                                                                    <div className='row g-4'>
                                                                        <div className='col-10'>
                                                                            <Input
                                                                                id="fileInput"
                                                                                type='file'
                                                                                autoComplete='photo'
                                                                                ariaLabel='Upload image file'
                                                                                onChange={handleFileChange}
                                                                            />
                                                                        </div>
                                                                        <div className='col-12'>
                                                                            <Button
                                                                                color='dark'
                                                                                isLight
                                                                                icon='Delete'
                                                                                onClick={handleDeleteAvatar}>
                                                                                Delete Avatar
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-0">
                                                <FormGroup id="admissionNo" label="Admission No / Roll Number" isFloating>
                                                    <Input type="text" placeholder="Admission No / Roll Number"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.admissionNo} disabled={userTypeId != 1} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-0">
                                                <FormGroup id="firstName" label="First Name" isFloating>
                                                    <Input type="text" placeholder="Enter First Name"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.firstName}
                                                        onBlur={updateStudentForm.handleBlur}
                                                        isValid={updateStudentForm.isValid}
                                                        isTouched={updateStudentForm.touched.firstName}
                                                        invalidFeedback={updateStudentForm.errors.firstName} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-0">
                                                <FormGroup id="lastName" label="Last Name" isFloating>
                                                    <Input type="text" placeholder="Enter Last Name"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.lastName} />
                                                </FormGroup>
                                            </div>

                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="studentNameTamil" label="Student Name (Tamil)" isFloating>
                                                    <Input type="text" placeholder="Enter Student Name (Tamil)"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.studentNameTamil} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15" >
                                                <FormGroup id="genderId" label="Gender" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select Gender"
                                                        onChange={(e: any) => setGenderId(e)}
                                                        value={genderId}
                                                        list={genderData.map((data: any) => (
                                                            { value: data.genderId, label: data.gender }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="dateOfBirth" label="Date Of Birth" isFloating>
                                                    <Input type="date" placeholder="Date Of Birth"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.dateOfBirth} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="smsToBeSentNumber" label="SMS Sent Number" isFloating>
                                                    <Input type="text" placeholder="SMS Sent Number"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.smsToBeSentNumber}
                                                        onBlur={updateStudentForm.handleBlur}
                                                        isValid={updateStudentForm.isValid}
                                                        isTouched={updateStudentForm.touched.smsToBeSentNumber}
                                                        invalidFeedback={updateStudentForm.errors.smsToBeSentNumber} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="email" label="Email" isFloating>
                                                    <Input type="text" placeholder="Enter Email"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.email}
                                                        onBlur={updateStudentForm.handleBlur}
                                                        isValid={updateStudentForm.isValid}
                                                        isTouched={updateStudentForm.touched.email}
                                                        invalidFeedback={updateStudentForm.errors.email} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="emisNo" label="EMIS No" isFloating>
                                                    <Input type="text" placeholder="Enter EMIS No"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.emisNo} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="aadharCard" label="Aadhar Number" isFloating>
                                                    <Input type="text" placeholder="Enter Aadhar Number"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.aadharCard}
                                                        onBlur={updateStudentForm.handleBlur}
                                                        isValid={updateStudentForm.isValid}
                                                        isTouched={updateStudentForm.touched.aadharCard}
                                                        invalidFeedback={updateStudentForm.errors.aadharCard} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="bloodGroupId" label="Blood Group" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select Blood Group"
                                                        onChange={(e: any) => setBloodGroupId(e)}
                                                        value={bloodGroupId}
                                                        list={bloodData.map((data: any) => (
                                                            { value: data.bloodGroupId, label: data.groupName }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="martialStatus" label="Marital Status" isFloating>
                                                    <Select ariaLabel="" placeholder="Select Marital Status"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.martialStatus}>
                                                        <option value='Married'>Married</option>
                                                        <option value='Un Married'>Un Married</option>
                                                    </Select>
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="motherTongue" label="Mother Tongue" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select Mother Tongue"
                                                        onChange={(e: any) => setMotherTongue(e)}
                                                        value={motherTongue}
                                                        list={motherTongueData.map((data: any) => (
                                                            { value: data.motherTongue, label: data.motherTongue }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="nationality" label="Nationality" isFloating>
                                                    <Select ariaLabel="" placeholder="Select Nationality"
                                                        onChange={selectNationality}
                                                        value={nationality}>
                                                        <option value='Indian'>Indian</option>
                                                        <option value='Others'>Others</option>
                                                    </Select>
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15 ">
                                                <FormGroup id="otherNation" label="Other Nation" isFloating>
                                                    <Input type="text" placeholder="Enter Country"
                                                        onInput={(e: any) => setOtherNationValue(e.target.value)}
                                                        value={otherNationValue} disabled={isOtherNation == 'Other' ? false : true} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="religionId" label="Religion" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select Religion"
                                                        onChange={(e: any) => setReligionId(e)}
                                                        value={religionId}
                                                        list={religionData.map((data: any) => (
                                                            { value: data.religionId, label: data.religion }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="category" label="Category" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select Category"
                                                        onChange={(e: any) => setCategory(e)}
                                                        value={category}
                                                        list={categoryData.map((data: any) => (
                                                            { value: data.category, label: data.category }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="casteDetailsId" label="Caste" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select Caste"
                                                        onChange={(e: any) => setCasteDetailsId(e)}
                                                        value={casteDetailsId}
                                                        list={casteDetailsData.map((data: any) => (
                                                            { value: data.casteDetailsId, label: data.casteName }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                <FormGroup id="subcaste" label="Sub Caste" isFloating>
                                                    <Input type="text" placeholder="Select Sub Caste"
                                                        onChange={updateStudentForm.handleChange}
                                                        value={updateStudentForm.values.subcaste} />
                                                </FormGroup>
                                            </div><div className="col-lg-3 mg-t-20 mg-lg-t-15" >
                                                <FormGroup id="physicallyChallenged" label="Physically Challenged" isFloating>
                                                    <Select ariaLabel="" placeholder="Select Physically Challenged"
                                                        onChange={selectPhysicallyChallenged}
                                                        value={physicallyChallenged}>
                                                        <option value='Yes'>Yes</option>
                                                        <option value='No'>No</option>
                                                    </Select>
                                                </FormGroup>
                                            </div>
                                            {isPhysicallyChallengedDetails == 'YES' ? <>
                                                <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                    <FormGroup id="physicallyChallengedType" label="physically Challenged Type" isFloating>
                                                        <Input type="text" placeholder="physically Challenged Type"
                                                            onChange={(e: any) => setPhysicallyChallengedTypeValue(e.target.value)}
                                                            value={physicallyChallengedTypeValue} />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-lg-3 mg-t-20 mg-lg-t-15">
                                                    <FormGroup id="physicallyChallengedPercentage" label="physically Challenged Percentage" isFloating>
                                                        <Input type="text" placeholder="physically Challenged Percentage"
                                                            onChange={(e: any) => setPhysicallyChallengedPercentageValue(e.target.value)}
                                                            value={physicallyChallengedPercentageValue}
                                                            onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                    </FormGroup>
                                                </div>
                                            </> : null}
                                        </div>
                                        <div style={{ textAlign: 'right' }} className="mt-4">
                                            <Button color="primary" type="submit" isLight>Next</Button>
                                        </div>
                                    </form>
                                </Card>
                            )}
                            {step == 1 && (
                                <Card shadow='none'>
                                    <form noValidate onSubmit={addressForm.handleSubmit}>

                                        <div className="row g-4">
                                            <CardLabel icon="LocationOn" color="info">
                                                <CardTitle className="h5">ADDRESS INFO</CardTitle>
                                            </CardLabel>
                                            <div className="col-lg-4">
                                                <FormGroup id="commAddr_FlatNo" label="Flat No Or Name" isFloating>
                                                    <Input type="text" placeholder="Flat No or Name"
                                                        onChange={addressForm.handleChange}
                                                        value={addressForm.values.commAddr_FlatNo} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="commAddr_Street" label="Street" isFloating>
                                                    <Input type="text" placeholder="Street"
                                                        onChange={addressForm.handleChange}
                                                        value={addressForm.values.commAddr_Street} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="commAddr_Area" label="Area/Locality" isFloating>
                                                    <Input type="text" placeholder="Area/Locality"
                                                        onChange={addressForm.handleChange}
                                                        value={addressForm.values.commAddr_Area} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="commAddr_StateId" label="State" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select State"
                                                        onChange={selectState}
                                                        value={commAddr_StateId}
                                                        list={statesData.map((data: any) => (
                                                            { value: data.stateId, label: data.stateName }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="commAddr_CityId" label="City" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select City"
                                                        onChange={selectCity}
                                                        value={commAddr_CityId}
                                                        list={cityData.map((data: any) => (
                                                            { value: data.cityId, label: data.cityName }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="commAddr_Pincode" label="PinCode" isFloating>
                                                    <Input type="text" placeholder="Enter PinCode"
                                                        onChange={addressForm.handleChange}
                                                        value={addressForm.values.commAddr_Pincode}
                                                        onBlur={addressForm.handleBlur}
                                                        isValid={addressForm.isValid}
                                                        isTouched={addressForm.touched.commAddr_Pincode}
                                                        invalidFeedback={addressForm.errors.commAddr_Pincode} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-12">
                                                <FormGroup id="checkbox">
                                                    <Checks
                                                        type='checkbox'
                                                        label='Permanent Address Same As Address For Communication Click Checkbox.'
                                                        onChange={address}
                                                        //checked={isChecked}
                                                        checked={permAddr_FlatNo != '' && permAddr_Street != '' && permAddr_Area != '' && permAddr_StateId?.value != undefined && permAddr_CityId?.value != undefined && permAddr_Pincode != '' ? true : isChecked}
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="permAddr_FlatNo" label="Flat No Or Name" isFloating>
                                                    <Input type="text" placeholder="Flat No or Name"
                                                        onInput={(e: any) => setPermAddr_FlatNo(e.target.value)}
                                                        value={permAddr_FlatNo} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="permAddr_Street" label="Street" isFloating>
                                                    <Input type="text" placeholder="Street"
                                                        onInput={(e: any) => setPermAddr_Street(e.target.value)}
                                                        value={permAddr_Street} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="permAddr_Area" label="Area/Locality" isFloating>
                                                    <Input type="text" placeholder="Area/Locality"
                                                        onInput={(e: any) => setPermAddr_Area(e.target.value)}
                                                        value={permAddr_Area} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="permAddr_StateId" label="State" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select State"
                                                        onChange={selectPermAddr_State}
                                                        value={permAddr_StateId}
                                                        list={permAddr_StateData.map((data: any) => (
                                                            { value: data.stateId, label: data.stateName }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="permAddr_CityId" label="City" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select City"
                                                        onChange={selectPermAddr_City}
                                                        value={permAddr_CityId}
                                                        list={permAddr_CityData.map((data: any) => (
                                                            { value: data.cityId, label: data.cityName }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="permAddr_Pincode" label="PinCode" isFloating>
                                                    <Input type="text" placeholder="Enter PinCode"
                                                        onInput={(e: any) => setPermAddr_Pincode(e.target.value)}
                                                        onChange={addressForm.handleChange}
                                                        value={permAddr_Pincode}
                                                        onBlur={addressForm.handleBlur}
                                                        isValid={addressForm.isValid}
                                                        isTouched={addressForm.touched.permAddr_Pincode}
                                                        invalidFeedback={addressForm.errors.permAddr_Pincode} />
                                                </FormGroup>
                                            </div>

                                            <div className="col-lg-12">
                                                <CardLabel icon="MonetizationOn" color="info">
                                                    <CardTitle className="h5">BANK INFO</CardTitle>
                                                </CardLabel>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="bankName" label="Bank Name" isFloating>
                                                    <Input type="text" placeholder="Enter Bank Name"
                                                        onChange={addressForm.handleChange}
                                                        value={addressForm.values.bankName} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="branch" label="Branch" isFloating>
                                                    <Input type="text" placeholder="Enter Branch"
                                                        onChange={addressForm.handleChange}
                                                        value={addressForm.values.branch} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="bankAccountNo" label="Bank Account No" isFloating>
                                                    <Input type="text" placeholder="Enter Bank Account No"
                                                        onChange={addressForm.handleChange}
                                                        value={addressForm.values.bankAccountNo} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="ifscCode" label="IFSC Code" isFloating>
                                                    <Input type="text" placeholder="Enter IFSC Code"
                                                        onChange={addressForm.handleChange}
                                                        value={addressForm.values.ifscCode} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-4">
                                                <FormGroup id="micrCode" label="MICR Code" isFloating>
                                                    <Input type="text" placeholder="Enter MICR Code"
                                                        onChange={addressForm.handleChange}
                                                        value={addressForm.values.micrCode} />
                                                </FormGroup>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }} className="mt-4">
                                            <Button color="primary" onClick={handlePrevious} type="submit" isLink>Previous</Button>
                                            <Button color="primary" type="submit" isLight>Next</Button>
                                        </div>
                                        {/* <CardFooter>
                                            <CardFooterLeft>
                                                <Button color="primary" onClick={handlePrevious} type="submit" isLink>Previous</Button>
                                            </CardFooterLeft>
                                            <CardFooterRight>
                                                <Button color="primary" type="submit" isLight>Next</Button>
                                            </CardFooterRight>
                                        </CardFooter> */}
                                    </form>
                                </Card>
                            )}
                            {step == 2 && (
                                <Card shadow='none'>
                                    <form noValidate onSubmit={classForm.handleSubmit}>
                                        <div className="row g-4">
                                            <div className="col-lg-3">
                                                <FormGroup id="department" label="Department" isFloating>
                                                    <Select ariaLabel="" placeholder="Select Department"
                                                        onChange={selectDepartment}
                                                        value={departmentId}
                                                        list={departmentData.map((data: any) => (
                                                            { value: data.departmentId, text: data.departmentName }
                                                        ))} disabled />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="courseId" label="Course" isFloating>
                                                    <Select ariaLabel="" placeholder="Select Course"
                                                        onChange={selectCourse}
                                                        value={courseId}
                                                        list={courseData.map((data: any) => (
                                                            { value: data.courseId, text: data.courseName }
                                                        ))} disabled />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="batchMasterId" label="Batch" isFloating>
                                                    <Select ariaLabel="" placeholder="Select Batch"
                                                        onChange={selectBatch}
                                                        value={batchMasterId}
                                                        list={batchMasterData.map((data: any) => (
                                                            { value: data.batchMasterId, text: data.batchName }
                                                        ))}
                                                        onBlur={classForm.handleBlur}
                                                        isValid={classForm.isValid}
                                                        isTouched={classForm.touched.batchMasterId}
                                                        invalidFeedback={classForm.errors.batchMasterId} disabled />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="semesterDetailsId" label="Semester" isFloating>
                                                    <Select ariaLabel="" placeholder="Select Semester"
                                                        onChange={selectSemester}
                                                        value={semesterDetailsId}
                                                        list={semesterDetailsData.map((data: any) => (
                                                            { value: data.semesterDetailsId, text: data.semesterNumber }
                                                        ))}
                                                        onBlur={classForm.handleBlur}
                                                        isValid={classForm.isValid}
                                                        isTouched={classForm.touched.semesterDetailsId}
                                                        invalidFeedback={classForm.errors.semesterDetailsId} disabled />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="sectionDetailsId" label="Section" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select Section"
                                                        onChange={selectSection}
                                                        value={sectionDetailsId}
                                                        list={sectionDetailsData.map((data: any) => (
                                                            { value: data.sectionDetailsId, label: data.sectionName }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="admissionDateStamp" label="Admission Date" isFloating>
                                                    <Input type='datetime-local' placeholder="Enter Admission Date"
                                                        onChange={classForm.handleChange}
                                                        value={classForm.values.admissionDateStamp} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="sourceName" label="Source" isFloating>
                                                    <Input type="text" placeholder="Enter Source"
                                                        onChange={classForm.handleChange}
                                                        value={classForm.values.sourceName} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="transferCourseId" label="Interested to Transfer the Course" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select Interested to Transfer the Course"
                                                        onChange={(e: any) => setTransferCourseId(e)}
                                                        value={transferCourseId}
                                                        list={interestedCourseData.map((data: any) => (
                                                            { value: data.courseId, label: data.courseName }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="referralTypeId" label="Reference (if any)" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select Reference (if any)"
                                                        onChange={selectReferralType}
                                                        value={referralTypeId}
                                                        list={referralTypeData.map((data: any) => (
                                                            { value: data.referralTypeId, label: data.referralType }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            {isReferralTypeOthers ?
                                                <div className="col-lg-3">
                                                    <FormGroup id="referredId" label="Reference" isFloating>
                                                        <SearchableSelect isFloating ariaLabel="" placeholder="Select Referred Person"
                                                            onChange={(e: any) => { setReferredId(e) }}
                                                            value={referredId}
                                                            list={userListByUserTypeData.map((data: any) => (
                                                                { value: data.referredId, label: data.registerNoForStudentAndStaff }
                                                            ))} />
                                                    </FormGroup>
                                                </div> : <div className="col-lg-3">
                                                    <FormGroup id="referredName" label="Referred Person" isFloating>
                                                        <Input type="text" placeholder="Enter Referred Person"
                                                            onInput={(e: any) => { setReferredName(e.target.value) }}
                                                            value={referredName} />
                                                    </FormGroup>
                                                </div>}
                                            <div className="col-lg-3">
                                                <FormGroup id="concessionTypeId" label="Concession Type" isFloating>
                                                    <SearchableSelect isFloating ariaLabel="" placeholder="Select Concession Type"
                                                        onChange={selectConcessionTypeId}
                                                        value={concessionTypeId}
                                                        list={concessionData.map((data: any) => (
                                                            { value: data.concessionTypeId, label: data.concessionType }
                                                        ))} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="concessionRemarks" label="Concession Remark" isFloating>
                                                    <Input type="text" placeholder="Enter Concession Remark"
                                                        onChange={classForm.handleChange}
                                                        onInput={(e: any) => setConcessionRemarks(e.target.value)}
                                                        value={concessionRemarks} disabled={concessionTypeId?.value != undefined ? false : true} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="interimCollegeTransfer" label="Interim College Transfer ?" isFloating>
                                                    <Select ariaLabel="" placeholder="Select Interim College Transfer ?"
                                                        onChange={selectInterimCollegeTransfer}
                                                        value={interimCollegeTransfer}>
                                                        <option value='Yes'>Yes</option>
                                                        <option value='No'>No</option>
                                                    </Select>
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="collegeName" label="College Name" isFloating>
                                                    <Input type="text" placeholder="Enter College Name"
                                                        onInput={(e: any) => setCollegeNameValue(e.target.value)}
                                                        value={collegeNameValue} disabled={interimCollegeTransfer == 'Yes' ? false : true} />
                                                </FormGroup>
                                            </div>
                                            {/* <div className="col-lg-3 ">
                                                <FormGroup id="isCollegeTransport" label="Transport" isFloating>
                                                    <Select ariaLabel="" placeholder="Select Transport"
                                                        onChange={selectTransport}
                                                        value={isCollegeTransport}>
                                                        <option value='Yes'>Yes</option>
                                                        <option value='No'>No</option>
                                                    </Select>
                                                </FormGroup>
                                            </div> */}
                                            {/* {isTransportDetails == 'isAreaDetails' ?
                                                <>
                                                    <div className="col-lg-3 ">
                                                        <FormGroup id="transportAreaMasterId" label="Area of Student" isFloating>
                                                            <Select ariaLabel="" placeholder="Select Area"
                                                                onChange={(e: any) => { setTransportAreaValue(e.target.value) }}
                                                                value={transportAreaValue}
                                                                list={transportAreaMasterData.map((data: any) => (
                                                                    { value: data.transportAreaMasterId, text: data.areaName }
                                                                ))} />
                                                        </FormGroup>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <FormGroup id="modeOfWays" label="Mode Of Ways" isFloating>
                                                            <Select ariaLabel="" placeholder="Select Ways"
                                                                onChange={(e: any) => { setModeValue(e.target.value) }}
                                                                value={modeValue}>
                                                                <option value='1'>One Way</option>
                                                                <option value='2'>Two Way</option>
                                                            </Select>
                                                        </FormGroup>
                                                    </div>
                                                </> : null} */}

                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }} className="mt-4">
                                            <Button color="primary" onClick={handlePrevious} type="submit" isLink>Previous</Button>
                                            <Button color="primary" type="submit" isLight>Next</Button>
                                        </div>

                                        {/* <CardFooter>
                                            <CardFooterLeft>
                                                <Button color="primary" onClick={handlePrevious} type="submit" isLink>Previous</Button>
                                            </CardFooterLeft>
                                            <CardFooterRight>
                                                <Button color="primary" type="submit" isLight>Next</Button>
                                            </CardFooterRight>
                                        </CardFooter> */}
                                    </form>
                                </Card>
                            )}
                            {step == 3 && (
                                <Card shadow='none'>
                                    <form noValidate onSubmit={familyForm.handleSubmit}>
                                        <div className="row g-4">
                                            <div className="col-lg-3">
                                                <FormGroup id="fatherName" label="Father Name" isFloating>
                                                    <Input type="text" placeholder="Enter Father Name"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.fatherName} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="father_AdharNumber" label="Father Aadhar Number" isFloating>
                                                    <Input type="text" placeholder="Enter Father Aadhar Number"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.father_AdharNumber}
                                                        onBlur={familyForm.handleBlur}
                                                        isValid={familyForm.isValid}
                                                        isTouched={familyForm.touched.father_AdharNumber}
                                                        invalidFeedback={familyForm.errors.father_AdharNumber} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="fatherOccupation" label="Father Occupation" isFloating>
                                                    <Select ariaLabel="" placeholder="Select Father Occupation"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.fatherOccupation}>
                                                        <option value='Job'>Job</option>
                                                        <option value='Business'>Business</option>
                                                    </Select>
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="natureofJoborBusiness" label="Nature of Job/Business" isFloating>
                                                    <Input type="text" placeholder="Enter Nature of Job/Business"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.natureofJoborBusiness} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="fatherContactNumber" label="Mobile Number" isFloating>
                                                    <Input type="text" placeholder="Enter Mobile Number"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.fatherContactNumber}
                                                        onBlur={familyForm.handleBlur}
                                                        isValid={familyForm.isValid}
                                                        isTouched={familyForm.touched.fatherContactNumber}
                                                        invalidFeedback={familyForm.errors.fatherContactNumber} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="fatherEmailId" label="Father Email Id" isFloating>
                                                    <Input type="text" placeholder="Enter Father Email Id"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.fatherEmailId}
                                                        onBlur={familyForm.handleBlur}
                                                        isValid={familyForm.isValid}
                                                        isTouched={familyForm.touched.fatherEmailId}
                                                        invalidFeedback={familyForm.errors.fatherEmailId} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="motherName" label="Mother Name" isFloating>
                                                    <Input type="text" placeholder="Enter Mother Name"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.motherName} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="mother_AdharNumber" label="Mother Aadhar Number" isFloating>
                                                    <Input type="text" placeholder="Enter Mother Aadhar Number"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.mother_AdharNumber}
                                                        onBlur={familyForm.handleBlur}
                                                        isValid={familyForm.isValid}
                                                        isTouched={familyForm.touched.mother_AdharNumber}
                                                        invalidFeedback={familyForm.errors.mother_AdharNumber} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="yearlyIncome" label="Yearly Income" isFloating>
                                                    <Input type="text" placeholder="Enter Yearly Income"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.yearlyIncome} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="positionHeld" label="Position held" isFloating>
                                                    <Input type="text" placeholder="Enter Position held"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.positionHeld} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup id="motherContactNumber" label="Mother Mobile Number" isFloating>
                                                    <Input type="text" placeholder="Enter Mother Mobile Number"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.motherContactNumber}
                                                        onBlur={familyForm.handleBlur}
                                                        isValid={familyForm.isValid}
                                                        isTouched={familyForm.touched.motherContactNumber}
                                                        invalidFeedback={familyForm.errors.motherContactNumber} />
                                                </FormGroup>
                                            </div>
                                            <div className="col-lg-12">
                                                <FormGroup id="isGuardian">
                                                    <Checks
                                                        type='checkbox'
                                                        label='Lives With Guardian Click Checkbox.'
                                                        onChange={handleCheckboxChange}
                                                        checked={isGuardian == 0 ? false : true}
                                                    />
                                                </FormGroup>
                                            </div>
                                            {isGuardian == '1' ? (<><div className="col-lg-3">
                                                <FormGroup id="guardian_Name" label="Guardian Name" isFloating>
                                                    <Input type="text" placeholder="Enter Guardian Name"
                                                        onChange={familyForm.handleChange}
                                                        value={familyForm.values.guardian_Name} />
                                                </FormGroup>
                                            </div>
                                                <div className="col-lg-3">
                                                    <FormGroup id="guardian_AdharNumber" label="Guardian Aadhar Number" isFloating>
                                                        <Input type="text" placeholder="Enter Guardian Aadhar Number"
                                                            onChange={familyForm.handleChange}
                                                            value={familyForm.values.guardian_AdharNumber}
                                                            onBlur={familyForm.handleBlur}
                                                            isValid={familyForm.isValid}
                                                            isTouched={familyForm.touched.guardian_AdharNumber}
                                                            invalidFeedback={familyForm.errors.guardian_AdharNumber} />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-lg-3">
                                                    <FormGroup id="guardian_phone" label="Guardian Mobile Number" isFloating>
                                                        <Input type="text" placeholder="Enter Guardian Mobile Number"
                                                            onChange={familyForm.handleChange}
                                                            value={familyForm.values.guardian_phone}
                                                            onBlur={familyForm.handleBlur}
                                                            isValid={familyForm.isValid}
                                                            isTouched={familyForm.touched.guardian_phone}
                                                            invalidFeedback={familyForm.errors.guardian_phone} />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-lg-3">
                                                    <FormGroup id="guardian_email" label="Guardian Email Id" isFloating>
                                                        <Input type="text" placeholder="Enter Guardian Email Id"
                                                            onChange={familyForm.handleChange}
                                                            value={familyForm.values.guardian_email}
                                                            onBlur={familyForm.handleBlur}
                                                            isValid={familyForm.isValid}
                                                            isTouched={familyForm.touched.guardian_email}
                                                            invalidFeedback={familyForm.errors.guardian_email} />
                                                    </FormGroup>
                                                </div> </>) : null}
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }} className="mt-4">
                                            <Button color="primary" onClick={handlePrevious} type="submit" isLink>Previous</Button>
                                            <Button color="primary" type="submit" isLight>Next</Button>
                                        </div>
                                        {/* <CardFooter>
                                            <CardFooterLeft>
                                                <Button color="primary" onClick={handlePrevious} type="submit" isLink>Previous</Button>
                                            </CardFooterLeft>
                                            <CardFooterRight>
                                                <Button color="primary" type="submit" isLight>Next</Button>
                                            </CardFooterRight>
                                        </CardFooter> */}
                                    </form>
                                </Card>
                            )}
                            {step == 4 && (
                                <Card shadow='none'>
                                    <form noValidate onSubmit={markForm.handleSubmit}>
                                        {/* <CardBody> */}
                                        <div className="row gap-4">
                                            <CardLabel icon="school" color="info">
                                                <CardTitle className="h5">STUDENT MARK INFO</CardTitle>
                                            </CardLabel>

                                            <div className="row">
                                                <table className='table table-modern table-hover text-nowrap'>
                                                    <thead >
                                                        <tr className='table-primary'>
                                                            <th >S.NO</th>
                                                            <th >CLASS</th>
                                                            <th >REGISTER NO</th>
                                                            <th >NAME & ADDRESS OF THE INSTITUTION</th>
                                                            <th >NAME OF BOARD</th>
                                                            <th >MEDIUM OF INSTRUCTION</th>
                                                            <th >MONTH & YEAR OF PASSING</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className="text-center fw-bold">1</td>
                                                            <td className="text-center fw-bold">10 STD</td>
                                                            <td><Input id='registerNo_X' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.registerNo_X} /></td>
                                                            <td><Input id='institutionNameAndAddress_X' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.institutionNameAndAddress_X} /></td>
                                                            <td><Input id='boardName_X' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.boardName_X} /></td>
                                                            <td><Input id='mediumOfInstitution_X' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.mediumOfInstitution_X} /></td>
                                                            <td><Input id='monthAndYearOfPassing_X' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.monthAndYearOfPassing_X} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center fw-bold">2</td>
                                                            <td className="text-center fw-bold">11 STD</td>
                                                            <td><Input id='registerNo_XI' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.registerNo_XI} /></td>
                                                            <td><Input id='institutionNameAndAddress_XI' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.institutionNameAndAddress_XI} /></td>
                                                            <td><Input id='boardName_XI' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.boardName_XI} /></td>
                                                            <td><Input id='mediumOfInstitution_XI' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.mediumOfInstitution_XI} /></td>
                                                            <td><Input id='monthAndYearOfPassing_XI' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.monthAndYearOfPassing_XI} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center fw-bold">3</td>
                                                            <td className="text-center fw-bold">12 STD</td>
                                                            <td><Input id='registerNo_XII' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.registerNo_XII} /></td>
                                                            <td><SearchableSelect id='XIISchoolNameId' ariaLabel="Select School" style={{ width: '80' }} placeholder="Select School"
                                                                onChange={(e: any) => setXIISchoolNameId(e)}
                                                                value={XIISchoolNameId}
                                                                list={studentSchoolNameData.map((data: any) => (
                                                                    { value: data.studentSchoolNameId, label: data.schoolName }
                                                                ))} /></td>
                                                            <td><Input id='boardName_XII' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.boardName_XII} /></td>
                                                            <td><Input id='mediumOfInstitution_XII' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.mediumOfInstitution_XII} /></td>
                                                            <td><Input id='monthAndYearOfPassing_XII' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.monthAndYearOfPassing_XII} /></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row">
                                                <FormGroup>
                                                    <span className="text-info h5" >
                                                        Details of Qualifying Examination
                                                    </span>
                                                </FormGroup>
                                            </div>
                                            <div className="row">
                                                <FormGroup>
                                                    <span className="text-info h5" >
                                                        (1). Marks In XI th Standard
                                                    </span>
                                                </FormGroup>
                                            </div>
                                            <div className="row">
                                                <table className='table table-modern table-hover text-nowrap'>
                                                    <thead >
                                                        <tr className='table-primary'>
                                                            <th >SUBJECT</th>
                                                            <th >MARKS SECURED</th>
                                                            <th >MAXIMUM  MARKS</th>
                                                            <th >MONTH & YEAR  OF PASSING</th>
                                                            <th >REGISTER NO</th>
                                                            <th >NO OF ATTEMPTS</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td><SearchableSelect id='XI_S1_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXI_S1_studentSchoolSubject(e)}
                                                                value={XI_S1_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XI_S1_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S1_markSecured} /></td>
                                                            <td><Input id='XI_S1_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S1_maximumMarks} /></td>
                                                            <td><Input id='XI_S1_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S1_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XI_S1_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S1_registerNo} /></td>
                                                            <td><Input id='XI_S1_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S1_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><SearchableSelect id='XI_S2_studentSchoolSubject' ariaLabel="Subject" placeholder="Subject"
                                                                onChange={(e: any) => setXI_S2_studentSchoolSubject(e)}
                                                                value={XI_S2_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XI_S2_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S2_markSecured} /></td>
                                                            <td><Input id='XI_S2_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S2_maximumMarks} /></td>
                                                            <td><Input id='XI_S2_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S2_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XI_S2_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S2_registerNo} /></td>
                                                            <td><Input id='XI_S2_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S2_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center fw-bold">Part-III Subjects</td>
                                                        </tr>
                                                        <tr>
                                                            <td><SearchableSelect id='XI_S3_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXI_S3_studentSchoolSubject(e)}
                                                                value={XI_S3_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XI_S3_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S3_markSecured} /></td>
                                                            <td><Input id='XI_S3_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S3_maximumMarks} /></td>
                                                            <td><Input id='XI_S3_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S3_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XI_S3_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S3_registerNo} /></td>
                                                            <td><Input id='XI_S3_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S3_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><SearchableSelect id='XI_S4_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXI_S4_studentSchoolSubject(e)}
                                                                value={XI_S4_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XI_S4_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S4_markSecured} /></td>
                                                            <td><Input id='XI_S4_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S4_maximumMarks} /></td>
                                                            <td><Input id='XI_S4_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S4_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XI_S4_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S4_registerNo} /></td>
                                                            <td><Input id='XI_S4_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S4_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><SearchableSelect id='XI_S5_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXI_S5_studentSchoolSubject(e)}
                                                                value={XI_S5_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XI_S5_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S5_markSecured} /></td>
                                                            <td><Input id='XI_S5_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S5_maximumMarks} /></td>
                                                            <td><Input id='XI_S5_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S5_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XI_S5_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S5_registerNo} /></td>
                                                            <td><Input id='XI_S5_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S5_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><SearchableSelect id='XI_S6_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXI_S6_studentSchoolSubject(e)}
                                                                value={XI_S6_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XI_S6_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S6_markSecured} /></td>
                                                            <td><Input id='XI_S6_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S6_maximumMarks} /></td>
                                                            <td><Input id='XI_S6_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S6_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XI_S6_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S6_registerNo} /></td>
                                                            <td><Input id='XI_S6_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_S6_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center fw-bold">TOTAL</td>
                                                            <td><Input id='XI_OverAll_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                onInput={(e: any) => setTotalPercentageForXI(e.target.value)}
                                                                value={markForm.values.XI_OverAll_markSecured} /></td>
                                                            <td><Input id='XI_OverAll_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XI_OverAll_maximumMarks} /></td>
                                                            <td className="text-center fw-bold">TOTAL PERCENTAGE</td>
                                                            <td><Input id='' type="text" style={{ width: '80' }} disabled
                                                                value={(Number(totalPercentageForXI) / Number(600) * 100).toFixed(2)} /></td>
                                                            <td><Input id='' type="text" style={{ width: '80' }} disabled /></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row">
                                                <FormGroup>
                                                    <span className="text-info h5" >
                                                        (2).Marks In XII th Standard
                                                    </span>
                                                </FormGroup>
                                            </div>
                                            <div className="row">
                                                <table className='table table-modern table-hover  text-nowrap'>
                                                    <thead>
                                                        <tr className='table-primary'>
                                                            <th >SUBJECT</th>
                                                            <th >MARKS SECURED</th>
                                                            <th >MAXIMUM MARKS</th>
                                                            <th >MONTH & YEAR OF PASSING</th>
                                                            <th >REGISTER NO</th>
                                                            <th >NO OF ATTEMPTS</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td><SearchableSelect id='XII_S1_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXII_S1_studentSchoolSubject(e)}
                                                                value={XII_S1_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XII_S1_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S1_markSecured} /></td>
                                                            <td><Input id='XII_S1_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S1_maximumMarks} /></td>
                                                            <td><Input id='XII_S1_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S1_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XII_S1_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S1_registerNo} /></td>
                                                            <td><Input id='XII_S1_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S1_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><SearchableSelect id='XII_S2_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXII_S2_studentSchoolSubject(e)}
                                                                value={XII_S2_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XII_S2_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S2_markSecured} /></td>
                                                            <td><Input id='XII_S2_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S2_maximumMarks} /></td>
                                                            <td><Input id='XII_S2_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S2_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XII_S2_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S2_registerNo} /></td>
                                                            <td><Input id='XII_S2_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S2_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center fw-bold">Part-III Subjects</td>
                                                        </tr>
                                                        <tr>
                                                            <td><SearchableSelect id='XII_S3_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXII_S3_studentSchoolSubject(e)}
                                                                value={XII_S3_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XII_S3_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S3_markSecured} /></td>
                                                            <td><Input id='XII_S3_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S3_maximumMarks} /></td>
                                                            <td><Input id='XII_S3_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S3_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XII_S3_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S3_registerNo} /></td>
                                                            <td><Input id='XII_S3_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S3_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><SearchableSelect id='XII_S4_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXII_S4_studentSchoolSubject(e)}
                                                                value={XII_S4_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XII_S4_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S4_markSecured} /></td>
                                                            <td><Input id='XII_S4_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S4_maximumMarks} /></td>
                                                            <td><Input id='XII_S4_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S4_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XII_S4_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S4_registerNo} /></td>
                                                            <td><Input id='XII_S4_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S4_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><SearchableSelect id='XII_S5_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXII_S5_studentSchoolSubject(e)}
                                                                value={XII_S5_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XII_S5_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S5_markSecured} /></td>
                                                            <td><Input id='XII_S5_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S5_maximumMarks} /></td>
                                                            <td><Input id='XII_S5_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S5_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XII_S5_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S5_registerNo} /></td>
                                                            <td><Input id='XII_S5_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S5_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td><SearchableSelect id='XII_S6_studentSchoolSubject' ariaLabel="" placeholder="Subject"
                                                                onChange={(e: any) => setXII_S6_studentSchoolSubject(e)}
                                                                value={XII_S6_studentSchoolSubject}
                                                                list={studentSchoolSubjectData.map((data: any) => (
                                                                    { value: data.studentSchoolSubjectId, label: data.subjectName }
                                                                ))} /></td>
                                                            <td><Input id='XII_S6_markSecured' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S6_markSecured} /></td>
                                                            <td><Input id='XII_S6_maximumMarks' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S6_maximumMarks} /></td>
                                                            <td><Input id='XII_S6_monthAndYearOfPassing' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S6_monthAndYearOfPassing} /></td>
                                                            <td><Input id='XII_S6_registerNo' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S6_registerNo} /></td>
                                                            <td><Input id='XII_S6_noOfAttempts' type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_S6_noOfAttempts} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center fw-bold">TOTAL</td>
                                                            <td><Input id="XII_OverAll_markSecured" type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                onInput={(e: any) => setTotalPercentageForXII(e.target.value)}
                                                                value={markForm.values.XII_OverAll_markSecured} /></td>
                                                            <td><Input id="XII_OverAll_maximumMarks" type="text" style={{ width: '80' }}
                                                                onChange={markForm.handleChange}
                                                                value={markForm.values.XII_OverAll_maximumMarks} /></td>
                                                            <td className="text-center fw-bold">TOTAL PERCENTAGE</td>
                                                            <td><Input type="text" style={{ width: '80' }} disabled
                                                                value={(Number(totalPercentageForXII) / Number(600) * 100).toFixed(2)} /></td>
                                                            <td><Input type="text" style={{ width: '80' }} disabled /></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            {ugDegree ? <>
                                                <div className="row">
                                                    <div className="col-lg-4">
                                                        <FormGroup >
                                                            <span className="text-info h5" >
                                                                (3). Name of the UG Course (if any) :
                                                            </span>
                                                        </FormGroup>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <Input type="text" placeholder="Enter UG Course Name"
                                                            onChange={markForm.handleChange}
                                                            value={markForm.values.UG_courseName} />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <table className="table table-modern table-hover text-center text-nowrap text-nowrap text-lg-nowrap">
                                                        <thead >
                                                            <tr className='table-primary'>
                                                                <th >SUBJECT</th>
                                                                <th >MARKS SECURED</th>
                                                                <th >MAXIMUM MARKS</th>
                                                                <th >PERCENTAGE <br /> OF MARKS %</th>
                                                                <th >CLASS OBTAINED</th>
                                                                <th >NO OF ATTEMPTS</th>
                                                                <th >REGISTER NO</th>
                                                                <th >MONTH & YEAR  <br /> OF PASSING</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td ><Input id="UG_Part1_SubjectName" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part1_SubjectName} /></td>
                                                                <td><Input id="UG_Part1_MarksObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part1_MarksObtained} /></td>
                                                                <td><Input id="UG_Part1_MaximumMarks" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part1_MaximumMarks} /></td>

                                                                <td><Input id="UG_Part1_Percentage" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part1_Percentage} /></td>
                                                                <td><Input id="UG_Part1_ClassObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part1_ClassObtained} /></td>
                                                                <td><Input id="UG_Part1_NoOfAttempts" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part1_NoOfAttempts} /></td>
                                                                <td><Input id="UG_Part1_RegisterNo" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part1_RegisterNo} /></td>
                                                                <td><Input id="UG_Part1_Passing" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part1_Passing} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td ><Input id="UG_Part2_SubjectName" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part2_SubjectName} /></td>
                                                                <td><Input id="UG_Part2_MarksObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part2_MarksObtained} /></td>
                                                                <td><Input id="UG_Part2_MaximumMarks" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part2_MaximumMarks} /></td>
                                                                <td><Input id="UG_Part2_Percentage" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part2_Percentage} /></td>
                                                                <td><Input id="UG_Part2_ClassObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part2_ClassObtained} /></td>
                                                                <td><Input id="UG_Part2_NoOfAttempts" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part2_NoOfAttempts} /></td>
                                                                <td><Input id="UG_Part2_RegisterNo" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part2_RegisterNo} /></td>
                                                                <td><Input id="UG_Part2_Passing" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part2_Passing} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td ><Input id="UG_Part3_SubjectName" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part3_SubjectName} /></td>
                                                                <td><Input id="UG_Part3_MarksObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part3_MarksObtained} /></td>
                                                                <td><Input id="UG_Part3_MaximumMarks" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part3_MaximumMarks} /></td>
                                                                <td><Input id="UG_Part3_Percentage" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part3_Percentage} /></td>
                                                                <td><Input id="UG_Part3_ClassObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part3_ClassObtained} /></td>
                                                                <td><Input id="UG_Part3_NoOfAttempts" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part3_NoOfAttempts} /></td>
                                                                <td><Input id="UG_Part3_RegisterNo" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part3_RegisterNo} /></td>
                                                                <td><Input id="UG_Part3_Passing" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Part3_Passing} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td ><Input id="UG_Allied1_SubjectName" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied1_SubjectName} /></td>
                                                                <td><Input id="UG_Allied1_MarksObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied1_MarksObtained} /></td>
                                                                <td><Input id="UG_Allied1_MaximumMarks" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied1_MaximumMarks} /></td>
                                                                <td><Input id="UG_Allied1_Percentage" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied1_Percentage} /></td>
                                                                <td><Input id="UG_Allied1_ClassObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied1_ClassObtained} /></td>
                                                                <td><Input id="UG_Allied1_NoOfAttempts" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied1_NoOfAttempts} /></td>
                                                                <td><Input id="UG_Allied1_RegisterNo" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied1_RegisterNo} /></td>
                                                                <td><Input id="UG_Allied1_Passing" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied1_Passing} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td ><Input id="UG_Allied2_SubjectName" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied2_SubjectName} /></td>
                                                                <td><Input id="UG_Allied2_MarksObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied2_MarksObtained} /></td>
                                                                <td><Input id="UG_Allied2_MaximumMarks" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied2_MaximumMarks} /></td>
                                                                <td><Input id="UG_Allied2_Percentage" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied2_Percentage} /></td>
                                                                <td><Input id="UG_Allied2_ClassObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied2_ClassObtained} /></td>
                                                                <td><Input id="UG_Allied2_NoOfAttempts" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied2_NoOfAttempts} /></td>
                                                                <td><Input id="UG_Allied2_RegisterNo" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied2_RegisterNo} /></td>
                                                                <td><Input id="UG_Allied2_Passing" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Allied2_Passing} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center fw-bold">Percentage</td>
                                                                <td className="text-center fw-bold">Main/Core</td>
                                                                <td><Input id="UG_Overall_Main_Core" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Overall_Main_Core} /></td>
                                                                <td className="text-center fw-bold">Ancy./Allied</td>
                                                                <td><Input id="UG_Overall_Ancy_Allied" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Overall_Ancy_Allied} /></td>
                                                                <td className="text-center fw-bold">Part - III</td>
                                                                <td><Input id="UG_Overall_Part3" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.UG_Overall_Part3} /></td>
                                                                <td><Input id="XII_OverAll_markSecured" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.XII_OverAll_markSecured} disabled /></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </> : null}
                                            {pgDegree ? <>
                                                <div className="row">
                                                    <div className="col-lg-4">
                                                        <FormGroup >
                                                            <span className="text-info h5" >
                                                                (4). Name of the PG Course (if any) :
                                                            </span>
                                                        </FormGroup>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <Input type="text" placeholder="Enter PG Course Name"
                                                            onChange={markForm.handleChange}
                                                            value={markForm.values.PG_courseName} />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <table className="table table-modern table-hover text-center text-nowrap text-nowrap">
                                                        <thead>
                                                            <tr className='table-primary'>
                                                                <th ><>SUBJECT</></th>
                                                                <th ><>MARKS SECURED</></th>
                                                                <th ><>MAXIMUM MARKS</></th>
                                                                <th ><>PERCENTAGE OF MARKS %</></th>
                                                                <th ><>CLASS OBTAINED</></th>
                                                                <th ><>NO OF ATTEMPTS</></th>
                                                                <th ><>REGISTER NO</></th>
                                                                <th ><>MONTH & YEAR OF PASSING</></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td ><Input id="PG_Part1_SubjectName" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part1_SubjectName} /></td>
                                                                <td><Input id="PG_Part1_MarksObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part1_MarksObtained} /></td>
                                                                <td><Input id="PG_Part1_MaximumMarks" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part1_MaximumMarks} /></td>
                                                                <td><Input id="PG_Part1_Percentage" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part1_Percentage} /></td>
                                                                <td><Input id="PG_Part1_ClassObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part1_ClassObtained} /></td>
                                                                <td><Input id="PG_Part1_NoOfAttempts" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part1_NoOfAttempts} /></td>
                                                                <td><Input id="PG_Part1_RegisterNo" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part1_RegisterNo} /></td>
                                                                <td><Input id="PG_Part1_Passing" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part1_Passing} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td ><Input id="PG_Part2_SubjectName" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part2_SubjectName} /></td>
                                                                <td><Input id="PG_Part2_MarksObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part2_MarksObtained} /></td>
                                                                <td><Input id="PG_Part2_MaximumMarks" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part2_MaximumMarks} /></td>
                                                                <td><Input id="PG_Part2_Percentage" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part2_Percentage} /></td>
                                                                <td><Input id="PG_Part2_ClassObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part2_ClassObtained} /></td>
                                                                <td><Input id="PG_Part2_NoOfAttempts" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part2_NoOfAttempts} /></td>
                                                                <td><Input id="PG_Part2_RegisterNo" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part2_RegisterNo} /></td>
                                                                <td><Input id="PG_Part2_Passing" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part2_Passing} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td ><Input id="PG_Part3_SubjectName" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part3_SubjectName} /></td>
                                                                <td><Input id="PG_Part3_MarksObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part3_MarksObtained} /></td>
                                                                <td><Input id="PG_Part3_MaximumMarks" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part3_MaximumMarks} /></td>
                                                                <td><Input id="PG_Part3_Percentage" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part3_Percentage} /></td>
                                                                <td><Input id="PG_Part3_ClassObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part3_ClassObtained} /></td>
                                                                <td><Input id="PG_Part3_NoOfAttempts" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part3_NoOfAttempts} /></td>
                                                                <td><Input id="PG_Part3_RegisterNo" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part3_RegisterNo} /></td>
                                                                <td><Input id="PG_Part3_Passing" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Part3_Passing} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td ><Input id="PG_Allied1_SubjectName" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied1_SubjectName} /></td>
                                                                <td><Input id="PG_Allied1_MarksObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied1_MarksObtained} /></td>
                                                                <td><Input id="PG_Allied1_MaximumMarks" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied1_MaximumMarks} /></td>
                                                                <td><Input id="PG_Allied1_Percentage" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied1_Percentage} /></td>
                                                                <td><Input id="PG_Allied1_ClassObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied1_ClassObtained} /></td>
                                                                <td><Input id="PG_Allied1_NoOfAttempts" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied1_NoOfAttempts} /></td>
                                                                <td><Input id="PG_Allied1_RegisterNo" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied1_RegisterNo} /></td>
                                                                <td><Input id="PG_Allied1_Passing" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied1_Passing} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td ><Input id="PG_Allied2_SubjectName" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied2_SubjectName} /></td>
                                                                <td><Input id="PG_Allied2_MarksObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied2_MarksObtained} /></td>
                                                                <td><Input id="PG_Allied2_MaximumMarks" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied2_MaximumMarks} /></td>
                                                                <td><Input id="PG_Allied2_Percentage" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied2_Percentage} /></td>
                                                                <td><Input id="PG_Allied2_ClassObtained" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied2_ClassObtained} /></td>
                                                                <td><Input id="PG_Allied2_NoOfAttempts" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied2_NoOfAttempts} /></td>
                                                                <td><Input id="PG_Allied2_RegisterNo" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied2_RegisterNo} /></td>
                                                                <td><Input id="PG_Allied2_Passing" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Allied2_Passing} /></td>
                                                            </tr>
                                                            <tr className='table-primary'>
                                                                <td className="text-center fw-bold">Percentage</td>
                                                                <td className="text-center fw-bold">Main/Core</td>
                                                                <td><Input id="PG_Overall_Main_Core" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Overall_Main_Core} /></td>
                                                                <td className="text-center fw-bold">Ancy./Allied</td>
                                                                <td><Input id="PG_Overall_Ancy_Allied" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Overall_Ancy_Allied} /></td>
                                                                <td className="text-center fw-bold">Part - III</td>
                                                                <td><Input id="PG_Overall_Part3" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.PG_Overall_Part3} /></td>
                                                                <td><Input id="XII_OverAll_markSecured" type="text" style={{ width: '10' }}
                                                                    onChange={markForm.handleChange}
                                                                    value={markForm.values.XII_OverAll_markSecured} disabled /></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </> : null}
                                            {/* <div className="row">
                                    <div className="col-lg-4">
                                        <FormGroup >
                                            <span className="text-info h5" >
                                                (5). Name of the MPhil Course (if any) :
                                            </span>
                                        </FormGroup>
                                    </div>
                                    <div className="col-lg-6">
                                        <Input id="MPhil_courseName" type="text" placeholder="Enter MPhil Course Name" 
                                            onChange={markForm.handleChange}
                                            value={markForm.values.MPhil_courseName}/>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <table className="table table-bordered text-nowrap">
                                        <thead>
                                            <tr>
                                                <th ><strong>SUBJECT</strong></th>
                                                <th ><strong>MARKS SECURED</strong></th>
                                                <th ><strong>MAXIMUM MARKS</strong></th>
                                                <th ><strong>PERCENTAGE OF MARKS %</strong></th>
                                                <th ><strong>CLASS OBTAINED</strong></th>
                                                <th ><strong>NO OF ATTEMPTS</strong></th>
                                                <th ><strong>REGISTER NO</strong></th>
                                                <th ><strong>MONTH & YEAR OF PASSING</strong></th>
                                            </tr>
                                        </thead>
                                    
                                    <tbody>
                                    <tr>
                                            <td ><Input id="MPhil_Part1_SubjectName" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part1_SubjectName} /></td>

                                            <td><Input id="MPhil_Part1_MarksObtained" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part1_MarksObtained} /></td>

                                            <td><Input id="MPhil_Part1_MaximumMarks" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part1_MaximumMarks} /></td>

                                            <td><Input id="MPhil_Part1_Percentage" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part1_Percentage} /></td>

                                            <td><Input id="MPhil_Part1_ClassObtained" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part1_ClassObtained} /></td>

                                            <td><Input id="MPhil_Part1_NoOfAttempts" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part1_NoOfAttempts} /></td>

                                            <td><Input id="MPhil_Part1_RegisterNo" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part1_RegisterNo} /></td>

                                            <td><Input id="MPhil_Part1_Passing" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part1_Passing} /></td>
                                        </tr>
                                        <tr>
                                            <td ><Input id="MPhil_Part2_SubjectName" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part2_SubjectName} /></td>

                                            <td><Input id="MPhil_Part2_MarksObtained" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part2_MarksObtained} /></td>

                                            <td><Input id="MPhil_Part2_MaximumMarks" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part2_MaximumMarks} /></td>

                                            <td><Input id="MPhil_Part2_Percentage" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part2_Percentage} /></td>

                                            <td><Input id="MPhil_Part2_ClassObtained" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part2_ClassObtained} /></td>

                                            <td><Input id="MPhil_Part2_NoOfAttempts" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part2_NoOfAttempts} /></td>

                                            <td><Input id="MPhil_Part2_RegisterNo" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part2_RegisterNo} /></td>

                                            <td><Input id="MPhil_Part2_Passing" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part2_Passing} /></td>
                                        </tr>
                                        <tr>
                                            <td ><Input id="MPhil_Part3_SubjectName" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part3_SubjectName} /></td>

                                            <td><Input id="MPhil_Part3_MarksObtained" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part3_MarksObtained} /></td>

                                            <td><Input id="MPhil_Part3_MaximumMarks" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part3_MaximumMarks} /></td>

                                            <td><Input id="MPhil_Part3_Percentage" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part3_Percentage} /></td>

                                            <td><Input id="MPhil_Part3_ClassObtained" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part3_ClassObtained} /></td>

                                            <td><Input id="MPhil_Part3_NoOfAttempts" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part3_NoOfAttempts} /></td>

                                            <td><Input id="MPhil_Part3_RegisterNo" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part3_RegisterNo} /></td>

                                            <td><Input id="MPhil_Part3_Passing" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Part3_Passing} /></td>
                                        </tr>
                                        <tr>
                                            <td ><Input id="MPhil_Allied1_SubjectName" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied1_SubjectName} /></td>

                                            <td><Input id="MPhil_Allied1_MarksObtained" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied1_MarksObtained} /></td>

                                            <td><Input id="MPhil_Allied1_MaximumMarks" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied1_MaximumMarks} /></td>

                                            <td><Input id="MPhil_Allied1_Percentage" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied1_Percentage} /></td>

                                            <td><Input id="MPhil_Allied1_ClassObtained" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied1_ClassObtained} /></td>

                                            <td><Input id="MPhil_Allied1_NoOfAttempts" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied1_NoOfAttempts} /></td>

                                            <td><Input id="MPhil_Allied1_RegisterNo" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied1_RegisterNo} /></td>

                                            <td><Input id="MPhil_Allied1_Passing" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied1_Passing} /></td>
                                        </tr>
                                        <tr>
                                            <td ><Input id="MPhil_Allied2_SubjectName" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied2_SubjectName} /></td>

                                            <td><Input id="MPhil_Allied2_MarksObtained" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied2_MarksObtained} /></td>

                                            <td><Input id="MPhil_Allied2_MaximumMarks" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied2_MaximumMarks} /></td>

                                            <td><Input id="MPhil_Allied2_Percentage" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied2_Percentage} /></td>

                                            <td><Input id="MPhil_Allied2_ClassObtained" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied2_ClassObtained} /></td>

                                            <td><Input id="MPhil_Allied2_NoOfAttempts" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied2_NoOfAttempts} /></td>

                                            <td><Input id="MPhil_Allied2_RegisterNo" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied2_RegisterNo} /></td>

                                            <td><Input id="MPhil_Allied2_Passing" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Allied2_Passing} /></td>
                                        </tr>
                                        <tr>
                                            <td className="text-center fw-bold">Percentage</td>
                                            <td className="text-center fw-bold">Main/Core</td>
                                            <td><Input id="MPhil_Overall_Main_Core" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Overall_Main_Core} /></td>
                                            <td className="text-center fw-bold">Ancy./Allied</td>
                                            <td><Input id="MPhil_Overall_Ancy_Allied" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Overall_Ancy_Allied} /></td>
                                            <td className="text-center fw-bold">Part - III</td>
                                            <td><Input id="MPhil_Overall_Part3" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.MPhil_Overall_Part3} /></td>
                                            <td><Input id="XII_OverAll_markSecured" type="text" style={{ width: '10' }}
                                                onChange={markForm.handleChange}
                                                value={markForm.values.XII_OverAll_markSecured} disabled/></td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </div> */}
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }} className="mt-4">
                                            <Button color="primary" onClick={handlePrevious} type="submit" isLink>Previous</Button>
                                            <Button color="primary" type="submit">Submit</Button>
                                        </div>

                                        {/* </CardBody> */}
                                    </form>
                                </Card>
                            )}
                        </CardBody>
                    </Card>
                </Page>

                <AlertService setIsOpen={setIsOpen} isOpen={isOpen} alertStatus={alertStatus} isNavigate={isNavigate} />

            </PageWrapper>
        </>
    )
}
export default UpdateStudent;